import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  date: any;
  json: any;
  point: any;
  timestamptz: any;
  uuid: any;
};

/** expression to compare columns of type Boolean. All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

export type Credentials = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginObject = {
  __typename?: 'LoginObject';
  accessToken: Scalars['String'];
  id: Scalars['String'];
};

export type SignUpCredentials = {
  displayName: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

/** expression to compare columns of type String. All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  _nlike?: Maybe<Scalars['String']>;
  _nsimilar?: Maybe<Scalars['String']>;
  _similar?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  displayName: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['String'];
};

export type UserOutput = {
  __typename?: 'UserOutput';
  id: Scalars['uuid'];
};

/** columns and relationships of "consumption_enteries" */
export type Consumption_Enteries = {
  __typename?: 'consumption_enteries';
  consumption_entry_id: Scalars['String'];
  consumption_type_id: Scalars['String'];
  id: Scalars['uuid'];
  product_entry_id: Scalars['String'];
  rating_10_after?: Maybe<Scalars['String']>;
  rating_10_before?: Maybe<Scalars['String']>;
  rating_10_question_id?: Maybe<Scalars['String']>;
  rating_1_after: Scalars['String'];
  rating_1_before: Scalars['String'];
  rating_1_question_id: Scalars['String'];
  rating_2_after: Scalars['String'];
  rating_2_before: Scalars['String'];
  rating_2_question_id: Scalars['String'];
  rating_3_after: Scalars['String'];
  rating_3_before: Scalars['String'];
  rating_3_question_id: Scalars['String'];
  rating_4_after: Scalars['String'];
  rating_4_before: Scalars['String'];
  rating_4_question_id: Scalars['String'];
  rating_5_after: Scalars['String'];
  rating_5_before: Scalars['String'];
  rating_5_question_id: Scalars['String'];
  rating_6_after?: Maybe<Scalars['String']>;
  rating_6_before?: Maybe<Scalars['String']>;
  rating_6_question_id?: Maybe<Scalars['String']>;
  rating_7_after?: Maybe<Scalars['String']>;
  rating_7_before?: Maybe<Scalars['String']>;
  rating_7_question_id?: Maybe<Scalars['String']>;
  rating_8_after?: Maybe<Scalars['String']>;
  rating_8_before?: Maybe<Scalars['String']>;
  rating_8_question_id?: Maybe<Scalars['String']>;
  rating_9_after?: Maybe<Scalars['String']>;
  rating_9_before?: Maybe<Scalars['String']>;
  rating_9_question_id?: Maybe<Scalars['String']>;
  user_description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating?: Maybe<Scalars['String']>;
};

/** aggregated selection of "consumption_enteries" */
export type Consumption_Enteries_Aggregate = {
  __typename?: 'consumption_enteries_aggregate';
  aggregate?: Maybe<Consumption_Enteries_Aggregate_Fields>;
  nodes: Array<Consumption_Enteries>;
};

/** aggregate fields of "consumption_enteries" */
export type Consumption_Enteries_Aggregate_Fields = {
  __typename?: 'consumption_enteries_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Consumption_Enteries_Max_Fields>;
  min?: Maybe<Consumption_Enteries_Min_Fields>;
};


/** aggregate fields of "consumption_enteries" */
export type Consumption_Enteries_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Consumption_Enteries_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "consumption_enteries" */
export type Consumption_Enteries_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Consumption_Enteries_Max_Order_By>;
  min?: Maybe<Consumption_Enteries_Min_Order_By>;
};

/** input type for inserting array relation for remote table "consumption_enteries" */
export type Consumption_Enteries_Arr_Rel_Insert_Input = {
  data: Array<Consumption_Enteries_Insert_Input>;
  on_conflict?: Maybe<Consumption_Enteries_On_Conflict>;
};

/** Boolean expression to filter rows from the table "consumption_enteries". All fields are combined with a logical 'AND'. */
export type Consumption_Enteries_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Consumption_Enteries_Bool_Exp>>>;
  _not?: Maybe<Consumption_Enteries_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Consumption_Enteries_Bool_Exp>>>;
  consumption_entry_id?: Maybe<String_Comparison_Exp>;
  consumption_type_id?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  product_entry_id?: Maybe<String_Comparison_Exp>;
  rating_10_after?: Maybe<String_Comparison_Exp>;
  rating_10_before?: Maybe<String_Comparison_Exp>;
  rating_10_question_id?: Maybe<String_Comparison_Exp>;
  rating_1_after?: Maybe<String_Comparison_Exp>;
  rating_1_before?: Maybe<String_Comparison_Exp>;
  rating_1_question_id?: Maybe<String_Comparison_Exp>;
  rating_2_after?: Maybe<String_Comparison_Exp>;
  rating_2_before?: Maybe<String_Comparison_Exp>;
  rating_2_question_id?: Maybe<String_Comparison_Exp>;
  rating_3_after?: Maybe<String_Comparison_Exp>;
  rating_3_before?: Maybe<String_Comparison_Exp>;
  rating_3_question_id?: Maybe<String_Comparison_Exp>;
  rating_4_after?: Maybe<String_Comparison_Exp>;
  rating_4_before?: Maybe<String_Comparison_Exp>;
  rating_4_question_id?: Maybe<String_Comparison_Exp>;
  rating_5_after?: Maybe<String_Comparison_Exp>;
  rating_5_before?: Maybe<String_Comparison_Exp>;
  rating_5_question_id?: Maybe<String_Comparison_Exp>;
  rating_6_after?: Maybe<String_Comparison_Exp>;
  rating_6_before?: Maybe<String_Comparison_Exp>;
  rating_6_question_id?: Maybe<String_Comparison_Exp>;
  rating_7_after?: Maybe<String_Comparison_Exp>;
  rating_7_before?: Maybe<String_Comparison_Exp>;
  rating_7_question_id?: Maybe<String_Comparison_Exp>;
  rating_8_after?: Maybe<String_Comparison_Exp>;
  rating_8_before?: Maybe<String_Comparison_Exp>;
  rating_8_question_id?: Maybe<String_Comparison_Exp>;
  rating_9_after?: Maybe<String_Comparison_Exp>;
  rating_9_before?: Maybe<String_Comparison_Exp>;
  rating_9_question_id?: Maybe<String_Comparison_Exp>;
  user_description?: Maybe<String_Comparison_Exp>;
  user_id?: Maybe<String_Comparison_Exp>;
  user_rating?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "consumption_enteries" */
export enum Consumption_Enteries_Constraint {
  /** unique or primary key constraint */
  ConsumptionEnteriesConsumptionEntryIdKey = 'consumption_enteries_consumption_entry_id_key',
  /** unique or primary key constraint */
  ConsumptionEnteriesIdKey = 'consumption_enteries_id_key',
  /** unique or primary key constraint */
  ConsumptionEnteriesPkey = 'consumption_enteries_pkey'
}

/** input type for inserting data into table "consumption_enteries" */
export type Consumption_Enteries_Insert_Input = {
  consumption_entry_id?: Maybe<Scalars['String']>;
  consumption_type_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  product_entry_id?: Maybe<Scalars['String']>;
  rating_10_after?: Maybe<Scalars['String']>;
  rating_10_before?: Maybe<Scalars['String']>;
  rating_10_question_id?: Maybe<Scalars['String']>;
  rating_1_after?: Maybe<Scalars['String']>;
  rating_1_before?: Maybe<Scalars['String']>;
  rating_1_question_id?: Maybe<Scalars['String']>;
  rating_2_after?: Maybe<Scalars['String']>;
  rating_2_before?: Maybe<Scalars['String']>;
  rating_2_question_id?: Maybe<Scalars['String']>;
  rating_3_after?: Maybe<Scalars['String']>;
  rating_3_before?: Maybe<Scalars['String']>;
  rating_3_question_id?: Maybe<Scalars['String']>;
  rating_4_after?: Maybe<Scalars['String']>;
  rating_4_before?: Maybe<Scalars['String']>;
  rating_4_question_id?: Maybe<Scalars['String']>;
  rating_5_after?: Maybe<Scalars['String']>;
  rating_5_before?: Maybe<Scalars['String']>;
  rating_5_question_id?: Maybe<Scalars['String']>;
  rating_6_after?: Maybe<Scalars['String']>;
  rating_6_before?: Maybe<Scalars['String']>;
  rating_6_question_id?: Maybe<Scalars['String']>;
  rating_7_after?: Maybe<Scalars['String']>;
  rating_7_before?: Maybe<Scalars['String']>;
  rating_7_question_id?: Maybe<Scalars['String']>;
  rating_8_after?: Maybe<Scalars['String']>;
  rating_8_before?: Maybe<Scalars['String']>;
  rating_8_question_id?: Maybe<Scalars['String']>;
  rating_9_after?: Maybe<Scalars['String']>;
  rating_9_before?: Maybe<Scalars['String']>;
  rating_9_question_id?: Maybe<Scalars['String']>;
  user_description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Consumption_Enteries_Max_Fields = {
  __typename?: 'consumption_enteries_max_fields';
  consumption_entry_id?: Maybe<Scalars['String']>;
  consumption_type_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  product_entry_id?: Maybe<Scalars['String']>;
  rating_10_after?: Maybe<Scalars['String']>;
  rating_10_before?: Maybe<Scalars['String']>;
  rating_10_question_id?: Maybe<Scalars['String']>;
  rating_1_after?: Maybe<Scalars['String']>;
  rating_1_before?: Maybe<Scalars['String']>;
  rating_1_question_id?: Maybe<Scalars['String']>;
  rating_2_after?: Maybe<Scalars['String']>;
  rating_2_before?: Maybe<Scalars['String']>;
  rating_2_question_id?: Maybe<Scalars['String']>;
  rating_3_after?: Maybe<Scalars['String']>;
  rating_3_before?: Maybe<Scalars['String']>;
  rating_3_question_id?: Maybe<Scalars['String']>;
  rating_4_after?: Maybe<Scalars['String']>;
  rating_4_before?: Maybe<Scalars['String']>;
  rating_4_question_id?: Maybe<Scalars['String']>;
  rating_5_after?: Maybe<Scalars['String']>;
  rating_5_before?: Maybe<Scalars['String']>;
  rating_5_question_id?: Maybe<Scalars['String']>;
  rating_6_after?: Maybe<Scalars['String']>;
  rating_6_before?: Maybe<Scalars['String']>;
  rating_6_question_id?: Maybe<Scalars['String']>;
  rating_7_after?: Maybe<Scalars['String']>;
  rating_7_before?: Maybe<Scalars['String']>;
  rating_7_question_id?: Maybe<Scalars['String']>;
  rating_8_after?: Maybe<Scalars['String']>;
  rating_8_before?: Maybe<Scalars['String']>;
  rating_8_question_id?: Maybe<Scalars['String']>;
  rating_9_after?: Maybe<Scalars['String']>;
  rating_9_before?: Maybe<Scalars['String']>;
  rating_9_question_id?: Maybe<Scalars['String']>;
  user_description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "consumption_enteries" */
export type Consumption_Enteries_Max_Order_By = {
  consumption_entry_id?: Maybe<Order_By>;
  consumption_type_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  product_entry_id?: Maybe<Order_By>;
  rating_10_after?: Maybe<Order_By>;
  rating_10_before?: Maybe<Order_By>;
  rating_10_question_id?: Maybe<Order_By>;
  rating_1_after?: Maybe<Order_By>;
  rating_1_before?: Maybe<Order_By>;
  rating_1_question_id?: Maybe<Order_By>;
  rating_2_after?: Maybe<Order_By>;
  rating_2_before?: Maybe<Order_By>;
  rating_2_question_id?: Maybe<Order_By>;
  rating_3_after?: Maybe<Order_By>;
  rating_3_before?: Maybe<Order_By>;
  rating_3_question_id?: Maybe<Order_By>;
  rating_4_after?: Maybe<Order_By>;
  rating_4_before?: Maybe<Order_By>;
  rating_4_question_id?: Maybe<Order_By>;
  rating_5_after?: Maybe<Order_By>;
  rating_5_before?: Maybe<Order_By>;
  rating_5_question_id?: Maybe<Order_By>;
  rating_6_after?: Maybe<Order_By>;
  rating_6_before?: Maybe<Order_By>;
  rating_6_question_id?: Maybe<Order_By>;
  rating_7_after?: Maybe<Order_By>;
  rating_7_before?: Maybe<Order_By>;
  rating_7_question_id?: Maybe<Order_By>;
  rating_8_after?: Maybe<Order_By>;
  rating_8_before?: Maybe<Order_By>;
  rating_8_question_id?: Maybe<Order_By>;
  rating_9_after?: Maybe<Order_By>;
  rating_9_before?: Maybe<Order_By>;
  rating_9_question_id?: Maybe<Order_By>;
  user_description?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_rating?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Consumption_Enteries_Min_Fields = {
  __typename?: 'consumption_enteries_min_fields';
  consumption_entry_id?: Maybe<Scalars['String']>;
  consumption_type_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  product_entry_id?: Maybe<Scalars['String']>;
  rating_10_after?: Maybe<Scalars['String']>;
  rating_10_before?: Maybe<Scalars['String']>;
  rating_10_question_id?: Maybe<Scalars['String']>;
  rating_1_after?: Maybe<Scalars['String']>;
  rating_1_before?: Maybe<Scalars['String']>;
  rating_1_question_id?: Maybe<Scalars['String']>;
  rating_2_after?: Maybe<Scalars['String']>;
  rating_2_before?: Maybe<Scalars['String']>;
  rating_2_question_id?: Maybe<Scalars['String']>;
  rating_3_after?: Maybe<Scalars['String']>;
  rating_3_before?: Maybe<Scalars['String']>;
  rating_3_question_id?: Maybe<Scalars['String']>;
  rating_4_after?: Maybe<Scalars['String']>;
  rating_4_before?: Maybe<Scalars['String']>;
  rating_4_question_id?: Maybe<Scalars['String']>;
  rating_5_after?: Maybe<Scalars['String']>;
  rating_5_before?: Maybe<Scalars['String']>;
  rating_5_question_id?: Maybe<Scalars['String']>;
  rating_6_after?: Maybe<Scalars['String']>;
  rating_6_before?: Maybe<Scalars['String']>;
  rating_6_question_id?: Maybe<Scalars['String']>;
  rating_7_after?: Maybe<Scalars['String']>;
  rating_7_before?: Maybe<Scalars['String']>;
  rating_7_question_id?: Maybe<Scalars['String']>;
  rating_8_after?: Maybe<Scalars['String']>;
  rating_8_before?: Maybe<Scalars['String']>;
  rating_8_question_id?: Maybe<Scalars['String']>;
  rating_9_after?: Maybe<Scalars['String']>;
  rating_9_before?: Maybe<Scalars['String']>;
  rating_9_question_id?: Maybe<Scalars['String']>;
  user_description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "consumption_enteries" */
export type Consumption_Enteries_Min_Order_By = {
  consumption_entry_id?: Maybe<Order_By>;
  consumption_type_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  product_entry_id?: Maybe<Order_By>;
  rating_10_after?: Maybe<Order_By>;
  rating_10_before?: Maybe<Order_By>;
  rating_10_question_id?: Maybe<Order_By>;
  rating_1_after?: Maybe<Order_By>;
  rating_1_before?: Maybe<Order_By>;
  rating_1_question_id?: Maybe<Order_By>;
  rating_2_after?: Maybe<Order_By>;
  rating_2_before?: Maybe<Order_By>;
  rating_2_question_id?: Maybe<Order_By>;
  rating_3_after?: Maybe<Order_By>;
  rating_3_before?: Maybe<Order_By>;
  rating_3_question_id?: Maybe<Order_By>;
  rating_4_after?: Maybe<Order_By>;
  rating_4_before?: Maybe<Order_By>;
  rating_4_question_id?: Maybe<Order_By>;
  rating_5_after?: Maybe<Order_By>;
  rating_5_before?: Maybe<Order_By>;
  rating_5_question_id?: Maybe<Order_By>;
  rating_6_after?: Maybe<Order_By>;
  rating_6_before?: Maybe<Order_By>;
  rating_6_question_id?: Maybe<Order_By>;
  rating_7_after?: Maybe<Order_By>;
  rating_7_before?: Maybe<Order_By>;
  rating_7_question_id?: Maybe<Order_By>;
  rating_8_after?: Maybe<Order_By>;
  rating_8_before?: Maybe<Order_By>;
  rating_8_question_id?: Maybe<Order_By>;
  rating_9_after?: Maybe<Order_By>;
  rating_9_before?: Maybe<Order_By>;
  rating_9_question_id?: Maybe<Order_By>;
  user_description?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_rating?: Maybe<Order_By>;
};

/** response of any mutation on the table "consumption_enteries" */
export type Consumption_Enteries_Mutation_Response = {
  __typename?: 'consumption_enteries_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Consumption_Enteries>;
};

/** input type for inserting object relation for remote table "consumption_enteries" */
export type Consumption_Enteries_Obj_Rel_Insert_Input = {
  data: Consumption_Enteries_Insert_Input;
  on_conflict?: Maybe<Consumption_Enteries_On_Conflict>;
};

/** on conflict condition type for table "consumption_enteries" */
export type Consumption_Enteries_On_Conflict = {
  constraint: Consumption_Enteries_Constraint;
  update_columns: Array<Consumption_Enteries_Update_Column>;
  where?: Maybe<Consumption_Enteries_Bool_Exp>;
};

/** ordering options when selecting data from "consumption_enteries" */
export type Consumption_Enteries_Order_By = {
  consumption_entry_id?: Maybe<Order_By>;
  consumption_type_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  product_entry_id?: Maybe<Order_By>;
  rating_10_after?: Maybe<Order_By>;
  rating_10_before?: Maybe<Order_By>;
  rating_10_question_id?: Maybe<Order_By>;
  rating_1_after?: Maybe<Order_By>;
  rating_1_before?: Maybe<Order_By>;
  rating_1_question_id?: Maybe<Order_By>;
  rating_2_after?: Maybe<Order_By>;
  rating_2_before?: Maybe<Order_By>;
  rating_2_question_id?: Maybe<Order_By>;
  rating_3_after?: Maybe<Order_By>;
  rating_3_before?: Maybe<Order_By>;
  rating_3_question_id?: Maybe<Order_By>;
  rating_4_after?: Maybe<Order_By>;
  rating_4_before?: Maybe<Order_By>;
  rating_4_question_id?: Maybe<Order_By>;
  rating_5_after?: Maybe<Order_By>;
  rating_5_before?: Maybe<Order_By>;
  rating_5_question_id?: Maybe<Order_By>;
  rating_6_after?: Maybe<Order_By>;
  rating_6_before?: Maybe<Order_By>;
  rating_6_question_id?: Maybe<Order_By>;
  rating_7_after?: Maybe<Order_By>;
  rating_7_before?: Maybe<Order_By>;
  rating_7_question_id?: Maybe<Order_By>;
  rating_8_after?: Maybe<Order_By>;
  rating_8_before?: Maybe<Order_By>;
  rating_8_question_id?: Maybe<Order_By>;
  rating_9_after?: Maybe<Order_By>;
  rating_9_before?: Maybe<Order_By>;
  rating_9_question_id?: Maybe<Order_By>;
  user_description?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_rating?: Maybe<Order_By>;
};

/** primary key columns input for table: "consumption_enteries" */
export type Consumption_Enteries_Pk_Columns_Input = {
  consumption_entry_id: Scalars['String'];
  id: Scalars['uuid'];
};

/** select columns of table "consumption_enteries" */
export enum Consumption_Enteries_Select_Column {
  /** column name */
  ConsumptionEntryId = 'consumption_entry_id',
  /** column name */
  ConsumptionTypeId = 'consumption_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProductEntryId = 'product_entry_id',
  /** column name */
  Rating_10After = 'rating_10_after',
  /** column name */
  Rating_10Before = 'rating_10_before',
  /** column name */
  Rating_10QuestionId = 'rating_10_question_id',
  /** column name */
  Rating_1After = 'rating_1_after',
  /** column name */
  Rating_1Before = 'rating_1_before',
  /** column name */
  Rating_1QuestionId = 'rating_1_question_id',
  /** column name */
  Rating_2After = 'rating_2_after',
  /** column name */
  Rating_2Before = 'rating_2_before',
  /** column name */
  Rating_2QuestionId = 'rating_2_question_id',
  /** column name */
  Rating_3After = 'rating_3_after',
  /** column name */
  Rating_3Before = 'rating_3_before',
  /** column name */
  Rating_3QuestionId = 'rating_3_question_id',
  /** column name */
  Rating_4After = 'rating_4_after',
  /** column name */
  Rating_4Before = 'rating_4_before',
  /** column name */
  Rating_4QuestionId = 'rating_4_question_id',
  /** column name */
  Rating_5After = 'rating_5_after',
  /** column name */
  Rating_5Before = 'rating_5_before',
  /** column name */
  Rating_5QuestionId = 'rating_5_question_id',
  /** column name */
  Rating_6After = 'rating_6_after',
  /** column name */
  Rating_6Before = 'rating_6_before',
  /** column name */
  Rating_6QuestionId = 'rating_6_question_id',
  /** column name */
  Rating_7After = 'rating_7_after',
  /** column name */
  Rating_7Before = 'rating_7_before',
  /** column name */
  Rating_7QuestionId = 'rating_7_question_id',
  /** column name */
  Rating_8After = 'rating_8_after',
  /** column name */
  Rating_8Before = 'rating_8_before',
  /** column name */
  Rating_8QuestionId = 'rating_8_question_id',
  /** column name */
  Rating_9After = 'rating_9_after',
  /** column name */
  Rating_9Before = 'rating_9_before',
  /** column name */
  Rating_9QuestionId = 'rating_9_question_id',
  /** column name */
  UserDescription = 'user_description',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserRating = 'user_rating'
}

/** input type for updating data in table "consumption_enteries" */
export type Consumption_Enteries_Set_Input = {
  consumption_entry_id?: Maybe<Scalars['String']>;
  consumption_type_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  product_entry_id?: Maybe<Scalars['String']>;
  rating_10_after?: Maybe<Scalars['String']>;
  rating_10_before?: Maybe<Scalars['String']>;
  rating_10_question_id?: Maybe<Scalars['String']>;
  rating_1_after?: Maybe<Scalars['String']>;
  rating_1_before?: Maybe<Scalars['String']>;
  rating_1_question_id?: Maybe<Scalars['String']>;
  rating_2_after?: Maybe<Scalars['String']>;
  rating_2_before?: Maybe<Scalars['String']>;
  rating_2_question_id?: Maybe<Scalars['String']>;
  rating_3_after?: Maybe<Scalars['String']>;
  rating_3_before?: Maybe<Scalars['String']>;
  rating_3_question_id?: Maybe<Scalars['String']>;
  rating_4_after?: Maybe<Scalars['String']>;
  rating_4_before?: Maybe<Scalars['String']>;
  rating_4_question_id?: Maybe<Scalars['String']>;
  rating_5_after?: Maybe<Scalars['String']>;
  rating_5_before?: Maybe<Scalars['String']>;
  rating_5_question_id?: Maybe<Scalars['String']>;
  rating_6_after?: Maybe<Scalars['String']>;
  rating_6_before?: Maybe<Scalars['String']>;
  rating_6_question_id?: Maybe<Scalars['String']>;
  rating_7_after?: Maybe<Scalars['String']>;
  rating_7_before?: Maybe<Scalars['String']>;
  rating_7_question_id?: Maybe<Scalars['String']>;
  rating_8_after?: Maybe<Scalars['String']>;
  rating_8_before?: Maybe<Scalars['String']>;
  rating_8_question_id?: Maybe<Scalars['String']>;
  rating_9_after?: Maybe<Scalars['String']>;
  rating_9_before?: Maybe<Scalars['String']>;
  rating_9_question_id?: Maybe<Scalars['String']>;
  user_description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating?: Maybe<Scalars['String']>;
};

/** update columns of table "consumption_enteries" */
export enum Consumption_Enteries_Update_Column {
  /** column name */
  ConsumptionEntryId = 'consumption_entry_id',
  /** column name */
  ConsumptionTypeId = 'consumption_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProductEntryId = 'product_entry_id',
  /** column name */
  Rating_10After = 'rating_10_after',
  /** column name */
  Rating_10Before = 'rating_10_before',
  /** column name */
  Rating_10QuestionId = 'rating_10_question_id',
  /** column name */
  Rating_1After = 'rating_1_after',
  /** column name */
  Rating_1Before = 'rating_1_before',
  /** column name */
  Rating_1QuestionId = 'rating_1_question_id',
  /** column name */
  Rating_2After = 'rating_2_after',
  /** column name */
  Rating_2Before = 'rating_2_before',
  /** column name */
  Rating_2QuestionId = 'rating_2_question_id',
  /** column name */
  Rating_3After = 'rating_3_after',
  /** column name */
  Rating_3Before = 'rating_3_before',
  /** column name */
  Rating_3QuestionId = 'rating_3_question_id',
  /** column name */
  Rating_4After = 'rating_4_after',
  /** column name */
  Rating_4Before = 'rating_4_before',
  /** column name */
  Rating_4QuestionId = 'rating_4_question_id',
  /** column name */
  Rating_5After = 'rating_5_after',
  /** column name */
  Rating_5Before = 'rating_5_before',
  /** column name */
  Rating_5QuestionId = 'rating_5_question_id',
  /** column name */
  Rating_6After = 'rating_6_after',
  /** column name */
  Rating_6Before = 'rating_6_before',
  /** column name */
  Rating_6QuestionId = 'rating_6_question_id',
  /** column name */
  Rating_7After = 'rating_7_after',
  /** column name */
  Rating_7Before = 'rating_7_before',
  /** column name */
  Rating_7QuestionId = 'rating_7_question_id',
  /** column name */
  Rating_8After = 'rating_8_after',
  /** column name */
  Rating_8Before = 'rating_8_before',
  /** column name */
  Rating_8QuestionId = 'rating_8_question_id',
  /** column name */
  Rating_9After = 'rating_9_after',
  /** column name */
  Rating_9Before = 'rating_9_before',
  /** column name */
  Rating_9QuestionId = 'rating_9_question_id',
  /** column name */
  UserDescription = 'user_description',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserRating = 'user_rating'
}

/** columns and relationships of "consumption_types" */
export type Consumption_Types = {
  __typename?: 'consumption_types';
  consumption_id: Scalars['uuid'];
  consumption_name: Scalars['String'];
};

/** aggregated selection of "consumption_types" */
export type Consumption_Types_Aggregate = {
  __typename?: 'consumption_types_aggregate';
  aggregate?: Maybe<Consumption_Types_Aggregate_Fields>;
  nodes: Array<Consumption_Types>;
};

/** aggregate fields of "consumption_types" */
export type Consumption_Types_Aggregate_Fields = {
  __typename?: 'consumption_types_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Consumption_Types_Max_Fields>;
  min?: Maybe<Consumption_Types_Min_Fields>;
};


/** aggregate fields of "consumption_types" */
export type Consumption_Types_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Consumption_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "consumption_types" */
export type Consumption_Types_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Consumption_Types_Max_Order_By>;
  min?: Maybe<Consumption_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "consumption_types" */
export type Consumption_Types_Arr_Rel_Insert_Input = {
  data: Array<Consumption_Types_Insert_Input>;
  on_conflict?: Maybe<Consumption_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "consumption_types". All fields are combined with a logical 'AND'. */
export type Consumption_Types_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Consumption_Types_Bool_Exp>>>;
  _not?: Maybe<Consumption_Types_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Consumption_Types_Bool_Exp>>>;
  consumption_id?: Maybe<Uuid_Comparison_Exp>;
  consumption_name?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "consumption_types" */
export enum Consumption_Types_Constraint {
  /** unique or primary key constraint */
  ConsumptionTypesPkey = 'consumption_types_pkey'
}

/** input type for inserting data into table "consumption_types" */
export type Consumption_Types_Insert_Input = {
  consumption_id?: Maybe<Scalars['uuid']>;
  consumption_name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Consumption_Types_Max_Fields = {
  __typename?: 'consumption_types_max_fields';
  consumption_id?: Maybe<Scalars['uuid']>;
  consumption_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "consumption_types" */
export type Consumption_Types_Max_Order_By = {
  consumption_id?: Maybe<Order_By>;
  consumption_name?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Consumption_Types_Min_Fields = {
  __typename?: 'consumption_types_min_fields';
  consumption_id?: Maybe<Scalars['uuid']>;
  consumption_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "consumption_types" */
export type Consumption_Types_Min_Order_By = {
  consumption_id?: Maybe<Order_By>;
  consumption_name?: Maybe<Order_By>;
};

/** response of any mutation on the table "consumption_types" */
export type Consumption_Types_Mutation_Response = {
  __typename?: 'consumption_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Consumption_Types>;
};

/** input type for inserting object relation for remote table "consumption_types" */
export type Consumption_Types_Obj_Rel_Insert_Input = {
  data: Consumption_Types_Insert_Input;
  on_conflict?: Maybe<Consumption_Types_On_Conflict>;
};

/** on conflict condition type for table "consumption_types" */
export type Consumption_Types_On_Conflict = {
  constraint: Consumption_Types_Constraint;
  update_columns: Array<Consumption_Types_Update_Column>;
  where?: Maybe<Consumption_Types_Bool_Exp>;
};

/** ordering options when selecting data from "consumption_types" */
export type Consumption_Types_Order_By = {
  consumption_id?: Maybe<Order_By>;
  consumption_name?: Maybe<Order_By>;
};

/** primary key columns input for table: "consumption_types" */
export type Consumption_Types_Pk_Columns_Input = {
  consumption_id: Scalars['uuid'];
};

/** select columns of table "consumption_types" */
export enum Consumption_Types_Select_Column {
  /** column name */
  ConsumptionId = 'consumption_id',
  /** column name */
  ConsumptionName = 'consumption_name'
}

/** input type for updating data in table "consumption_types" */
export type Consumption_Types_Set_Input = {
  consumption_id?: Maybe<Scalars['uuid']>;
  consumption_name?: Maybe<Scalars['String']>;
};

/** update columns of table "consumption_types" */
export enum Consumption_Types_Update_Column {
  /** column name */
  ConsumptionId = 'consumption_id',
  /** column name */
  ConsumptionName = 'consumption_name'
}


/** expression to compare columns of type date. All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: Maybe<Scalars['date']>;
  _gt?: Maybe<Scalars['date']>;
  _gte?: Maybe<Scalars['date']>;
  _in?: Maybe<Array<Scalars['date']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['date']>;
  _lte?: Maybe<Scalars['date']>;
  _neq?: Maybe<Scalars['date']>;
  _nin?: Maybe<Array<Scalars['date']>>;
};

/** columns and relationships of "entries" */
export type Entries = {
  __typename?: 'entries';
  batch_id?: Maybe<Scalars['String']>;
  cannabinoids?: Maybe<Scalars['String']>;
  chemotype?: Maybe<Scalars['String']>;
  consumption_type: Scalars['String'];
  created_at: Scalars['timestamptz'];
  dispensary?: Maybe<Scalars['String']>;
  genotype?: Maybe<Scalars['String']>;
  harvest_date?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  origin_city?: Maybe<Scalars['String']>;
  origin_country?: Maybe<Scalars['String']>;
  origin_county?: Maybe<Scalars['String']>;
  origin_state?: Maybe<Scalars['String']>;
  strain_id?: Maybe<Scalars['String']>;
  strain_name: Scalars['String'];
  terpenes?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  user_after_feeling?: Maybe<Scalars['String']>;
  user_before_feeling?: Maybe<Scalars['String']>;
  user_description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating?: Maybe<Scalars['String']>;
};

/** aggregated selection of "entries" */
export type Entries_Aggregate = {
  __typename?: 'entries_aggregate';
  aggregate?: Maybe<Entries_Aggregate_Fields>;
  nodes: Array<Entries>;
};

/** aggregate fields of "entries" */
export type Entries_Aggregate_Fields = {
  __typename?: 'entries_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Entries_Max_Fields>;
  min?: Maybe<Entries_Min_Fields>;
};


/** aggregate fields of "entries" */
export type Entries_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Entries_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "entries" */
export type Entries_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Entries_Max_Order_By>;
  min?: Maybe<Entries_Min_Order_By>;
};

/** input type for inserting array relation for remote table "entries" */
export type Entries_Arr_Rel_Insert_Input = {
  data: Array<Entries_Insert_Input>;
  on_conflict?: Maybe<Entries_On_Conflict>;
};

/** Boolean expression to filter rows from the table "entries". All fields are combined with a logical 'AND'. */
export type Entries_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Entries_Bool_Exp>>>;
  _not?: Maybe<Entries_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Entries_Bool_Exp>>>;
  batch_id?: Maybe<String_Comparison_Exp>;
  cannabinoids?: Maybe<String_Comparison_Exp>;
  chemotype?: Maybe<String_Comparison_Exp>;
  consumption_type?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  dispensary?: Maybe<String_Comparison_Exp>;
  genotype?: Maybe<String_Comparison_Exp>;
  harvest_date?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  origin_city?: Maybe<String_Comparison_Exp>;
  origin_country?: Maybe<String_Comparison_Exp>;
  origin_county?: Maybe<String_Comparison_Exp>;
  origin_state?: Maybe<String_Comparison_Exp>;
  strain_id?: Maybe<String_Comparison_Exp>;
  strain_name?: Maybe<String_Comparison_Exp>;
  terpenes?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user_after_feeling?: Maybe<String_Comparison_Exp>;
  user_before_feeling?: Maybe<String_Comparison_Exp>;
  user_description?: Maybe<String_Comparison_Exp>;
  user_id?: Maybe<String_Comparison_Exp>;
  user_rating?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "entries" */
export enum Entries_Constraint {
  /** unique or primary key constraint */
  EntriesPkey = 'entries_pkey'
}

/** input type for inserting data into table "entries" */
export type Entries_Insert_Input = {
  batch_id?: Maybe<Scalars['String']>;
  cannabinoids?: Maybe<Scalars['String']>;
  chemotype?: Maybe<Scalars['String']>;
  consumption_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dispensary?: Maybe<Scalars['String']>;
  genotype?: Maybe<Scalars['String']>;
  harvest_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  origin_city?: Maybe<Scalars['String']>;
  origin_country?: Maybe<Scalars['String']>;
  origin_county?: Maybe<Scalars['String']>;
  origin_state?: Maybe<Scalars['String']>;
  strain_id?: Maybe<Scalars['String']>;
  strain_name?: Maybe<Scalars['String']>;
  terpenes?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_after_feeling?: Maybe<Scalars['String']>;
  user_before_feeling?: Maybe<Scalars['String']>;
  user_description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Entries_Max_Fields = {
  __typename?: 'entries_max_fields';
  batch_id?: Maybe<Scalars['String']>;
  cannabinoids?: Maybe<Scalars['String']>;
  chemotype?: Maybe<Scalars['String']>;
  consumption_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dispensary?: Maybe<Scalars['String']>;
  genotype?: Maybe<Scalars['String']>;
  harvest_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  origin_city?: Maybe<Scalars['String']>;
  origin_country?: Maybe<Scalars['String']>;
  origin_county?: Maybe<Scalars['String']>;
  origin_state?: Maybe<Scalars['String']>;
  strain_id?: Maybe<Scalars['String']>;
  strain_name?: Maybe<Scalars['String']>;
  terpenes?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_after_feeling?: Maybe<Scalars['String']>;
  user_before_feeling?: Maybe<Scalars['String']>;
  user_description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "entries" */
export type Entries_Max_Order_By = {
  batch_id?: Maybe<Order_By>;
  cannabinoids?: Maybe<Order_By>;
  chemotype?: Maybe<Order_By>;
  consumption_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  dispensary?: Maybe<Order_By>;
  genotype?: Maybe<Order_By>;
  harvest_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  origin_city?: Maybe<Order_By>;
  origin_country?: Maybe<Order_By>;
  origin_county?: Maybe<Order_By>;
  origin_state?: Maybe<Order_By>;
  strain_id?: Maybe<Order_By>;
  strain_name?: Maybe<Order_By>;
  terpenes?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_after_feeling?: Maybe<Order_By>;
  user_before_feeling?: Maybe<Order_By>;
  user_description?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_rating?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Entries_Min_Fields = {
  __typename?: 'entries_min_fields';
  batch_id?: Maybe<Scalars['String']>;
  cannabinoids?: Maybe<Scalars['String']>;
  chemotype?: Maybe<Scalars['String']>;
  consumption_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dispensary?: Maybe<Scalars['String']>;
  genotype?: Maybe<Scalars['String']>;
  harvest_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  origin_city?: Maybe<Scalars['String']>;
  origin_country?: Maybe<Scalars['String']>;
  origin_county?: Maybe<Scalars['String']>;
  origin_state?: Maybe<Scalars['String']>;
  strain_id?: Maybe<Scalars['String']>;
  strain_name?: Maybe<Scalars['String']>;
  terpenes?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_after_feeling?: Maybe<Scalars['String']>;
  user_before_feeling?: Maybe<Scalars['String']>;
  user_description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "entries" */
export type Entries_Min_Order_By = {
  batch_id?: Maybe<Order_By>;
  cannabinoids?: Maybe<Order_By>;
  chemotype?: Maybe<Order_By>;
  consumption_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  dispensary?: Maybe<Order_By>;
  genotype?: Maybe<Order_By>;
  harvest_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  origin_city?: Maybe<Order_By>;
  origin_country?: Maybe<Order_By>;
  origin_county?: Maybe<Order_By>;
  origin_state?: Maybe<Order_By>;
  strain_id?: Maybe<Order_By>;
  strain_name?: Maybe<Order_By>;
  terpenes?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_after_feeling?: Maybe<Order_By>;
  user_before_feeling?: Maybe<Order_By>;
  user_description?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_rating?: Maybe<Order_By>;
};

/** response of any mutation on the table "entries" */
export type Entries_Mutation_Response = {
  __typename?: 'entries_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Entries>;
};

/** input type for inserting object relation for remote table "entries" */
export type Entries_Obj_Rel_Insert_Input = {
  data: Entries_Insert_Input;
  on_conflict?: Maybe<Entries_On_Conflict>;
};

/** on conflict condition type for table "entries" */
export type Entries_On_Conflict = {
  constraint: Entries_Constraint;
  update_columns: Array<Entries_Update_Column>;
  where?: Maybe<Entries_Bool_Exp>;
};

/** ordering options when selecting data from "entries" */
export type Entries_Order_By = {
  batch_id?: Maybe<Order_By>;
  cannabinoids?: Maybe<Order_By>;
  chemotype?: Maybe<Order_By>;
  consumption_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  dispensary?: Maybe<Order_By>;
  genotype?: Maybe<Order_By>;
  harvest_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  origin_city?: Maybe<Order_By>;
  origin_country?: Maybe<Order_By>;
  origin_county?: Maybe<Order_By>;
  origin_state?: Maybe<Order_By>;
  strain_id?: Maybe<Order_By>;
  strain_name?: Maybe<Order_By>;
  terpenes?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_after_feeling?: Maybe<Order_By>;
  user_before_feeling?: Maybe<Order_By>;
  user_description?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_rating?: Maybe<Order_By>;
};

/** primary key columns input for table: "entries" */
export type Entries_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "entries" */
export enum Entries_Select_Column {
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  Cannabinoids = 'cannabinoids',
  /** column name */
  Chemotype = 'chemotype',
  /** column name */
  ConsumptionType = 'consumption_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dispensary = 'dispensary',
  /** column name */
  Genotype = 'genotype',
  /** column name */
  HarvestDate = 'harvest_date',
  /** column name */
  Id = 'id',
  /** column name */
  OriginCity = 'origin_city',
  /** column name */
  OriginCountry = 'origin_country',
  /** column name */
  OriginCounty = 'origin_county',
  /** column name */
  OriginState = 'origin_state',
  /** column name */
  StrainId = 'strain_id',
  /** column name */
  StrainName = 'strain_name',
  /** column name */
  Terpenes = 'terpenes',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserAfterFeeling = 'user_after_feeling',
  /** column name */
  UserBeforeFeeling = 'user_before_feeling',
  /** column name */
  UserDescription = 'user_description',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserRating = 'user_rating'
}

/** input type for updating data in table "entries" */
export type Entries_Set_Input = {
  batch_id?: Maybe<Scalars['String']>;
  cannabinoids?: Maybe<Scalars['String']>;
  chemotype?: Maybe<Scalars['String']>;
  consumption_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dispensary?: Maybe<Scalars['String']>;
  genotype?: Maybe<Scalars['String']>;
  harvest_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  origin_city?: Maybe<Scalars['String']>;
  origin_country?: Maybe<Scalars['String']>;
  origin_county?: Maybe<Scalars['String']>;
  origin_state?: Maybe<Scalars['String']>;
  strain_id?: Maybe<Scalars['String']>;
  strain_name?: Maybe<Scalars['String']>;
  terpenes?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_after_feeling?: Maybe<Scalars['String']>;
  user_before_feeling?: Maybe<Scalars['String']>;
  user_description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating?: Maybe<Scalars['String']>;
};

/** update columns of table "entries" */
export enum Entries_Update_Column {
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  Cannabinoids = 'cannabinoids',
  /** column name */
  Chemotype = 'chemotype',
  /** column name */
  ConsumptionType = 'consumption_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dispensary = 'dispensary',
  /** column name */
  Genotype = 'genotype',
  /** column name */
  HarvestDate = 'harvest_date',
  /** column name */
  Id = 'id',
  /** column name */
  OriginCity = 'origin_city',
  /** column name */
  OriginCountry = 'origin_country',
  /** column name */
  OriginCounty = 'origin_county',
  /** column name */
  OriginState = 'origin_state',
  /** column name */
  StrainId = 'strain_id',
  /** column name */
  StrainName = 'strain_name',
  /** column name */
  Terpenes = 'terpenes',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserAfterFeeling = 'user_after_feeling',
  /** column name */
  UserBeforeFeeling = 'user_before_feeling',
  /** column name */
  UserDescription = 'user_description',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserRating = 'user_rating'
}


/** expression to compare columns of type json. All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: Maybe<Scalars['json']>;
  _gt?: Maybe<Scalars['json']>;
  _gte?: Maybe<Scalars['json']>;
  _in?: Maybe<Array<Scalars['json']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['json']>;
  _lte?: Maybe<Scalars['json']>;
  _neq?: Maybe<Scalars['json']>;
  _nin?: Maybe<Array<Scalars['json']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** perform the action: "createUser" */
  createUser?: Maybe<User>;
  /** delete data from the table: "consumption_enteries" */
  delete_consumption_enteries?: Maybe<Consumption_Enteries_Mutation_Response>;
  /** delete single row from the table: "consumption_enteries" */
  delete_consumption_enteries_by_pk?: Maybe<Consumption_Enteries>;
  /** delete data from the table: "consumption_types" */
  delete_consumption_types?: Maybe<Consumption_Types_Mutation_Response>;
  /** delete single row from the table: "consumption_types" */
  delete_consumption_types_by_pk?: Maybe<Consumption_Types>;
  /** delete data from the table: "entries" */
  delete_entries?: Maybe<Entries_Mutation_Response>;
  /** delete single row from the table: "entries" */
  delete_entries_by_pk?: Maybe<Entries>;
  /** delete data from the table: "product_entries" */
  delete_product_entries?: Maybe<Product_Entries_Mutation_Response>;
  /** delete single row from the table: "product_entries" */
  delete_product_entries_by_pk?: Maybe<Product_Entries>;
  /** delete data from the table: "profiles" */
  delete_profiles?: Maybe<Profiles_Mutation_Response>;
  /** delete single row from the table: "profiles" */
  delete_profiles_by_pk?: Maybe<Profiles>;
  /** delete data from the table: "strains" */
  delete_strains?: Maybe<Strains_Mutation_Response>;
  /** delete single row from the table: "strains" */
  delete_strains_by_pk?: Maybe<Strains>;
  /** delete data from the table: "user_profiles" */
  delete_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** delete single row from the table: "user_profiles" */
  delete_user_profiles_by_pk?: Maybe<User_Profiles>;
  /** delete data from the table: "user_ratings" */
  delete_user_ratings?: Maybe<User_Ratings_Mutation_Response>;
  /** delete single row from the table: "user_ratings" */
  delete_user_ratings_by_pk?: Maybe<User_Ratings>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** insert data into the table: "consumption_enteries" */
  insert_consumption_enteries?: Maybe<Consumption_Enteries_Mutation_Response>;
  /** insert a single row into the table: "consumption_enteries" */
  insert_consumption_enteries_one?: Maybe<Consumption_Enteries>;
  /** insert data into the table: "consumption_types" */
  insert_consumption_types?: Maybe<Consumption_Types_Mutation_Response>;
  /** insert a single row into the table: "consumption_types" */
  insert_consumption_types_one?: Maybe<Consumption_Types>;
  /** insert data into the table: "entries" */
  insert_entries?: Maybe<Entries_Mutation_Response>;
  /** insert a single row into the table: "entries" */
  insert_entries_one?: Maybe<Entries>;
  /** insert data into the table: "product_entries" */
  insert_product_entries?: Maybe<Product_Entries_Mutation_Response>;
  /** insert a single row into the table: "product_entries" */
  insert_product_entries_one?: Maybe<Product_Entries>;
  /** insert data into the table: "profiles" */
  insert_profiles?: Maybe<Profiles_Mutation_Response>;
  /** insert a single row into the table: "profiles" */
  insert_profiles_one?: Maybe<Profiles>;
  /** insert data into the table: "strains" */
  insert_strains?: Maybe<Strains_Mutation_Response>;
  /** insert a single row into the table: "strains" */
  insert_strains_one?: Maybe<Strains>;
  /** insert data into the table: "user_profiles" */
  insert_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** insert a single row into the table: "user_profiles" */
  insert_user_profiles_one?: Maybe<User_Profiles>;
  /** insert data into the table: "user_ratings" */
  insert_user_ratings?: Maybe<User_Ratings_Mutation_Response>;
  /** insert a single row into the table: "user_ratings" */
  insert_user_ratings_one?: Maybe<User_Ratings>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** perform the action: "login" */
  login?: Maybe<LoginObject>;
  /** update data of the table: "consumption_enteries" */
  update_consumption_enteries?: Maybe<Consumption_Enteries_Mutation_Response>;
  /** update single row of the table: "consumption_enteries" */
  update_consumption_enteries_by_pk?: Maybe<Consumption_Enteries>;
  /** update data of the table: "consumption_types" */
  update_consumption_types?: Maybe<Consumption_Types_Mutation_Response>;
  /** update single row of the table: "consumption_types" */
  update_consumption_types_by_pk?: Maybe<Consumption_Types>;
  /** update data of the table: "entries" */
  update_entries?: Maybe<Entries_Mutation_Response>;
  /** update single row of the table: "entries" */
  update_entries_by_pk?: Maybe<Entries>;
  /** update data of the table: "product_entries" */
  update_product_entries?: Maybe<Product_Entries_Mutation_Response>;
  /** update single row of the table: "product_entries" */
  update_product_entries_by_pk?: Maybe<Product_Entries>;
  /** update data of the table: "profiles" */
  update_profiles?: Maybe<Profiles_Mutation_Response>;
  /** update single row of the table: "profiles" */
  update_profiles_by_pk?: Maybe<Profiles>;
  /** update data of the table: "strains" */
  update_strains?: Maybe<Strains_Mutation_Response>;
  /** update single row of the table: "strains" */
  update_strains_by_pk?: Maybe<Strains>;
  /** update data of the table: "user_profiles" */
  update_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** update single row of the table: "user_profiles" */
  update_user_profiles_by_pk?: Maybe<User_Profiles>;
  /** update data of the table: "user_ratings" */
  update_user_ratings?: Maybe<User_Ratings_Mutation_Response>;
  /** update single row of the table: "user_ratings" */
  update_user_ratings_by_pk?: Maybe<User_Ratings>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
};


/** mutation root */
export type Mutation_RootCreateUserArgs = {
  credentials: SignUpCredentials;
};


/** mutation root */
export type Mutation_RootDelete_Consumption_EnteriesArgs = {
  where: Consumption_Enteries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Consumption_Enteries_By_PkArgs = {
  consumption_entry_id: Scalars['String'];
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Consumption_TypesArgs = {
  where: Consumption_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Consumption_Types_By_PkArgs = {
  consumption_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_EntriesArgs = {
  where: Entries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Entries_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_EntriesArgs = {
  where: Product_Entries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Entries_By_PkArgs = {
  product_entry_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ProfilesArgs = {
  where: Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Profiles_By_PkArgs = {
  user_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_StrainsArgs = {
  where: Strains_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Strains_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_ProfilesArgs = {
  where: User_Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Profiles_By_PkArgs = {
  user_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_RatingsArgs = {
  where: User_Ratings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Ratings_By_PkArgs = {
  user_rating_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsert_Consumption_EnteriesArgs = {
  objects: Array<Consumption_Enteries_Insert_Input>;
  on_conflict?: Maybe<Consumption_Enteries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consumption_Enteries_OneArgs = {
  object: Consumption_Enteries_Insert_Input;
  on_conflict?: Maybe<Consumption_Enteries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consumption_TypesArgs = {
  objects: Array<Consumption_Types_Insert_Input>;
  on_conflict?: Maybe<Consumption_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consumption_Types_OneArgs = {
  object: Consumption_Types_Insert_Input;
  on_conflict?: Maybe<Consumption_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EntriesArgs = {
  objects: Array<Entries_Insert_Input>;
  on_conflict?: Maybe<Entries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entries_OneArgs = {
  object: Entries_Insert_Input;
  on_conflict?: Maybe<Entries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_EntriesArgs = {
  objects: Array<Product_Entries_Insert_Input>;
  on_conflict?: Maybe<Product_Entries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Entries_OneArgs = {
  object: Product_Entries_Insert_Input;
  on_conflict?: Maybe<Product_Entries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProfilesArgs = {
  objects: Array<Profiles_Insert_Input>;
  on_conflict?: Maybe<Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Profiles_OneArgs = {
  object: Profiles_Insert_Input;
  on_conflict?: Maybe<Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StrainsArgs = {
  objects: Array<Strains_Insert_Input>;
  on_conflict?: Maybe<Strains_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Strains_OneArgs = {
  object: Strains_Insert_Input;
  on_conflict?: Maybe<Strains_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ProfilesArgs = {
  objects: Array<User_Profiles_Insert_Input>;
  on_conflict?: Maybe<User_Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Profiles_OneArgs = {
  object: User_Profiles_Insert_Input;
  on_conflict?: Maybe<User_Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_RatingsArgs = {
  objects: Array<User_Ratings_Insert_Input>;
  on_conflict?: Maybe<User_Ratings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Ratings_OneArgs = {
  object: User_Ratings_Insert_Input;
  on_conflict?: Maybe<User_Ratings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootLoginArgs = {
  credentials: Credentials;
};


/** mutation root */
export type Mutation_RootUpdate_Consumption_EnteriesArgs = {
  _set?: Maybe<Consumption_Enteries_Set_Input>;
  where: Consumption_Enteries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Consumption_Enteries_By_PkArgs = {
  _set?: Maybe<Consumption_Enteries_Set_Input>;
  pk_columns: Consumption_Enteries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Consumption_TypesArgs = {
  _set?: Maybe<Consumption_Types_Set_Input>;
  where: Consumption_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Consumption_Types_By_PkArgs = {
  _set?: Maybe<Consumption_Types_Set_Input>;
  pk_columns: Consumption_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EntriesArgs = {
  _set?: Maybe<Entries_Set_Input>;
  where: Entries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Entries_By_PkArgs = {
  _set?: Maybe<Entries_Set_Input>;
  pk_columns: Entries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_EntriesArgs = {
  _set?: Maybe<Product_Entries_Set_Input>;
  where: Product_Entries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Entries_By_PkArgs = {
  _set?: Maybe<Product_Entries_Set_Input>;
  pk_columns: Product_Entries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProfilesArgs = {
  _set?: Maybe<Profiles_Set_Input>;
  where: Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Profiles_By_PkArgs = {
  _set?: Maybe<Profiles_Set_Input>;
  pk_columns: Profiles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StrainsArgs = {
  _set?: Maybe<Strains_Set_Input>;
  where: Strains_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Strains_By_PkArgs = {
  _set?: Maybe<Strains_Set_Input>;
  pk_columns: Strains_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_ProfilesArgs = {
  _set?: Maybe<User_Profiles_Set_Input>;
  where: User_Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profiles_By_PkArgs = {
  _set?: Maybe<User_Profiles_Set_Input>;
  pk_columns: User_Profiles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_RatingsArgs = {
  _set?: Maybe<User_Ratings_Set_Input>;
  where: User_Ratings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Ratings_By_PkArgs = {
  _set?: Maybe<User_Ratings_Set_Input>;
  pk_columns: User_Ratings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _set?: Maybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _set?: Maybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};

/** column ordering options */
export enum Order_By {
  /** in the ascending order, nulls last */
  Asc = 'asc',
  /** in the ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in the ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in the descending order, nulls first */
  Desc = 'desc',
  /** in the descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in the descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}


/** expression to compare columns of type point. All fields are combined with logical 'AND'. */
export type Point_Comparison_Exp = {
  _eq?: Maybe<Scalars['point']>;
  _gt?: Maybe<Scalars['point']>;
  _gte?: Maybe<Scalars['point']>;
  _in?: Maybe<Array<Scalars['point']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['point']>;
  _lte?: Maybe<Scalars['point']>;
  _neq?: Maybe<Scalars['point']>;
  _nin?: Maybe<Array<Scalars['point']>>;
};

/** columns and relationships of "product_entries" */
export type Product_Entries = {
  __typename?: 'product_entries';
  batch_id: Scalars['String'];
  cbc?: Maybe<Scalars['String']>;
  cbd?: Maybe<Scalars['String']>;
  cbda?: Maybe<Scalars['String']>;
  cbg?: Maybe<Scalars['String']>;
  cbn?: Maybe<Scalars['String']>;
  comments_enabled: Scalars['Boolean'];
  created_at: Scalars['timestamptz'];
  delta8_thc?: Maybe<Scalars['String']>;
  dispensary_id?: Maybe<Scalars['String']>;
  fragrance_type_id?: Maybe<Scalars['String']>;
  harvest_date?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  origin_state?: Maybe<Scalars['String']>;
  product_entry_id: Scalars['String'];
  product_type_id: Scalars['String'];
  strain_id?: Maybe<Scalars['String']>;
  terpene_type_id?: Maybe<Scalars['String']>;
  thc?: Maybe<Scalars['String']>;
  thca?: Maybe<Scalars['String']>;
  thcv?: Maybe<Scalars['String']>;
  track_trace_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  user_description?: Maybe<Scalars['String']>;
  user_id: Scalars['String'];
  user_rating_delta?: Maybe<Scalars['String']>;
  user_rating_description_id?: Maybe<Scalars['String']>;
  variety_name: Scalars['String'];
};

/** aggregated selection of "product_entries" */
export type Product_Entries_Aggregate = {
  __typename?: 'product_entries_aggregate';
  aggregate?: Maybe<Product_Entries_Aggregate_Fields>;
  nodes: Array<Product_Entries>;
};

/** aggregate fields of "product_entries" */
export type Product_Entries_Aggregate_Fields = {
  __typename?: 'product_entries_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Product_Entries_Max_Fields>;
  min?: Maybe<Product_Entries_Min_Fields>;
};


/** aggregate fields of "product_entries" */
export type Product_Entries_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Product_Entries_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_entries" */
export type Product_Entries_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Product_Entries_Max_Order_By>;
  min?: Maybe<Product_Entries_Min_Order_By>;
};

/** input type for inserting array relation for remote table "product_entries" */
export type Product_Entries_Arr_Rel_Insert_Input = {
  data: Array<Product_Entries_Insert_Input>;
  on_conflict?: Maybe<Product_Entries_On_Conflict>;
};

/** Boolean expression to filter rows from the table "product_entries". All fields are combined with a logical 'AND'. */
export type Product_Entries_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Product_Entries_Bool_Exp>>>;
  _not?: Maybe<Product_Entries_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Product_Entries_Bool_Exp>>>;
  batch_id?: Maybe<String_Comparison_Exp>;
  cbc?: Maybe<String_Comparison_Exp>;
  cbd?: Maybe<String_Comparison_Exp>;
  cbda?: Maybe<String_Comparison_Exp>;
  cbg?: Maybe<String_Comparison_Exp>;
  cbn?: Maybe<String_Comparison_Exp>;
  comments_enabled?: Maybe<Boolean_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  delta8_thc?: Maybe<String_Comparison_Exp>;
  dispensary_id?: Maybe<String_Comparison_Exp>;
  fragrance_type_id?: Maybe<String_Comparison_Exp>;
  harvest_date?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  origin_state?: Maybe<String_Comparison_Exp>;
  product_entry_id?: Maybe<String_Comparison_Exp>;
  product_type_id?: Maybe<String_Comparison_Exp>;
  strain_id?: Maybe<String_Comparison_Exp>;
  terpene_type_id?: Maybe<String_Comparison_Exp>;
  thc?: Maybe<String_Comparison_Exp>;
  thca?: Maybe<String_Comparison_Exp>;
  thcv?: Maybe<String_Comparison_Exp>;
  track_trace_id?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user_description?: Maybe<String_Comparison_Exp>;
  user_id?: Maybe<String_Comparison_Exp>;
  user_rating_delta?: Maybe<String_Comparison_Exp>;
  user_rating_description_id?: Maybe<String_Comparison_Exp>;
  variety_name?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_entries" */
export enum Product_Entries_Constraint {
  /** unique or primary key constraint */
  ProductEntriesIdKey1 = 'product_entries_id_key1',
  /** unique or primary key constraint */
  ProductEntriesPkey1 = 'product_entries_pkey1'
}

/** input type for inserting data into table "product_entries" */
export type Product_Entries_Insert_Input = {
  batch_id?: Maybe<Scalars['String']>;
  cbc?: Maybe<Scalars['String']>;
  cbd?: Maybe<Scalars['String']>;
  cbda?: Maybe<Scalars['String']>;
  cbg?: Maybe<Scalars['String']>;
  cbn?: Maybe<Scalars['String']>;
  comments_enabled?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  delta8_thc?: Maybe<Scalars['String']>;
  dispensary_id?: Maybe<Scalars['String']>;
  fragrance_type_id?: Maybe<Scalars['String']>;
  harvest_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  origin_state?: Maybe<Scalars['String']>;
  product_entry_id?: Maybe<Scalars['String']>;
  product_type_id?: Maybe<Scalars['String']>;
  strain_id?: Maybe<Scalars['String']>;
  terpene_type_id?: Maybe<Scalars['String']>;
  thc?: Maybe<Scalars['String']>;
  thca?: Maybe<Scalars['String']>;
  thcv?: Maybe<Scalars['String']>;
  track_trace_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating_delta?: Maybe<Scalars['String']>;
  user_rating_description_id?: Maybe<Scalars['String']>;
  variety_name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Product_Entries_Max_Fields = {
  __typename?: 'product_entries_max_fields';
  batch_id?: Maybe<Scalars['String']>;
  cbc?: Maybe<Scalars['String']>;
  cbd?: Maybe<Scalars['String']>;
  cbda?: Maybe<Scalars['String']>;
  cbg?: Maybe<Scalars['String']>;
  cbn?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  delta8_thc?: Maybe<Scalars['String']>;
  dispensary_id?: Maybe<Scalars['String']>;
  fragrance_type_id?: Maybe<Scalars['String']>;
  harvest_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  origin_state?: Maybe<Scalars['String']>;
  product_entry_id?: Maybe<Scalars['String']>;
  product_type_id?: Maybe<Scalars['String']>;
  strain_id?: Maybe<Scalars['String']>;
  terpene_type_id?: Maybe<Scalars['String']>;
  thc?: Maybe<Scalars['String']>;
  thca?: Maybe<Scalars['String']>;
  thcv?: Maybe<Scalars['String']>;
  track_trace_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating_delta?: Maybe<Scalars['String']>;
  user_rating_description_id?: Maybe<Scalars['String']>;
  variety_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "product_entries" */
export type Product_Entries_Max_Order_By = {
  batch_id?: Maybe<Order_By>;
  cbc?: Maybe<Order_By>;
  cbd?: Maybe<Order_By>;
  cbda?: Maybe<Order_By>;
  cbg?: Maybe<Order_By>;
  cbn?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  delta8_thc?: Maybe<Order_By>;
  dispensary_id?: Maybe<Order_By>;
  fragrance_type_id?: Maybe<Order_By>;
  harvest_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  origin_state?: Maybe<Order_By>;
  product_entry_id?: Maybe<Order_By>;
  product_type_id?: Maybe<Order_By>;
  strain_id?: Maybe<Order_By>;
  terpene_type_id?: Maybe<Order_By>;
  thc?: Maybe<Order_By>;
  thca?: Maybe<Order_By>;
  thcv?: Maybe<Order_By>;
  track_trace_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_description?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_rating_delta?: Maybe<Order_By>;
  user_rating_description_id?: Maybe<Order_By>;
  variety_name?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Entries_Min_Fields = {
  __typename?: 'product_entries_min_fields';
  batch_id?: Maybe<Scalars['String']>;
  cbc?: Maybe<Scalars['String']>;
  cbd?: Maybe<Scalars['String']>;
  cbda?: Maybe<Scalars['String']>;
  cbg?: Maybe<Scalars['String']>;
  cbn?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  delta8_thc?: Maybe<Scalars['String']>;
  dispensary_id?: Maybe<Scalars['String']>;
  fragrance_type_id?: Maybe<Scalars['String']>;
  harvest_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  origin_state?: Maybe<Scalars['String']>;
  product_entry_id?: Maybe<Scalars['String']>;
  product_type_id?: Maybe<Scalars['String']>;
  strain_id?: Maybe<Scalars['String']>;
  terpene_type_id?: Maybe<Scalars['String']>;
  thc?: Maybe<Scalars['String']>;
  thca?: Maybe<Scalars['String']>;
  thcv?: Maybe<Scalars['String']>;
  track_trace_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating_delta?: Maybe<Scalars['String']>;
  user_rating_description_id?: Maybe<Scalars['String']>;
  variety_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "product_entries" */
export type Product_Entries_Min_Order_By = {
  batch_id?: Maybe<Order_By>;
  cbc?: Maybe<Order_By>;
  cbd?: Maybe<Order_By>;
  cbda?: Maybe<Order_By>;
  cbg?: Maybe<Order_By>;
  cbn?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  delta8_thc?: Maybe<Order_By>;
  dispensary_id?: Maybe<Order_By>;
  fragrance_type_id?: Maybe<Order_By>;
  harvest_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  origin_state?: Maybe<Order_By>;
  product_entry_id?: Maybe<Order_By>;
  product_type_id?: Maybe<Order_By>;
  strain_id?: Maybe<Order_By>;
  terpene_type_id?: Maybe<Order_By>;
  thc?: Maybe<Order_By>;
  thca?: Maybe<Order_By>;
  thcv?: Maybe<Order_By>;
  track_trace_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_description?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_rating_delta?: Maybe<Order_By>;
  user_rating_description_id?: Maybe<Order_By>;
  variety_name?: Maybe<Order_By>;
};

/** response of any mutation on the table "product_entries" */
export type Product_Entries_Mutation_Response = {
  __typename?: 'product_entries_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Product_Entries>;
};

/** input type for inserting object relation for remote table "product_entries" */
export type Product_Entries_Obj_Rel_Insert_Input = {
  data: Product_Entries_Insert_Input;
  on_conflict?: Maybe<Product_Entries_On_Conflict>;
};

/** on conflict condition type for table "product_entries" */
export type Product_Entries_On_Conflict = {
  constraint: Product_Entries_Constraint;
  update_columns: Array<Product_Entries_Update_Column>;
  where?: Maybe<Product_Entries_Bool_Exp>;
};

/** ordering options when selecting data from "product_entries" */
export type Product_Entries_Order_By = {
  batch_id?: Maybe<Order_By>;
  cbc?: Maybe<Order_By>;
  cbd?: Maybe<Order_By>;
  cbda?: Maybe<Order_By>;
  cbg?: Maybe<Order_By>;
  cbn?: Maybe<Order_By>;
  comments_enabled?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  delta8_thc?: Maybe<Order_By>;
  dispensary_id?: Maybe<Order_By>;
  fragrance_type_id?: Maybe<Order_By>;
  harvest_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  origin_state?: Maybe<Order_By>;
  product_entry_id?: Maybe<Order_By>;
  product_type_id?: Maybe<Order_By>;
  strain_id?: Maybe<Order_By>;
  terpene_type_id?: Maybe<Order_By>;
  thc?: Maybe<Order_By>;
  thca?: Maybe<Order_By>;
  thcv?: Maybe<Order_By>;
  track_trace_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_description?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_rating_delta?: Maybe<Order_By>;
  user_rating_description_id?: Maybe<Order_By>;
  variety_name?: Maybe<Order_By>;
};

/** primary key columns input for table: "product_entries" */
export type Product_Entries_Pk_Columns_Input = {
  product_entry_id: Scalars['String'];
};

/** select columns of table "product_entries" */
export enum Product_Entries_Select_Column {
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  Cbc = 'cbc',
  /** column name */
  Cbd = 'cbd',
  /** column name */
  Cbda = 'cbda',
  /** column name */
  Cbg = 'cbg',
  /** column name */
  Cbn = 'cbn',
  /** column name */
  CommentsEnabled = 'comments_enabled',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Delta8Thc = 'delta8_thc',
  /** column name */
  DispensaryId = 'dispensary_id',
  /** column name */
  FragranceTypeId = 'fragrance_type_id',
  /** column name */
  HarvestDate = 'harvest_date',
  /** column name */
  Id = 'id',
  /** column name */
  OriginState = 'origin_state',
  /** column name */
  ProductEntryId = 'product_entry_id',
  /** column name */
  ProductTypeId = 'product_type_id',
  /** column name */
  StrainId = 'strain_id',
  /** column name */
  TerpeneTypeId = 'terpene_type_id',
  /** column name */
  Thc = 'thc',
  /** column name */
  Thca = 'thca',
  /** column name */
  Thcv = 'thcv',
  /** column name */
  TrackTraceId = 'track_trace_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserDescription = 'user_description',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserRatingDelta = 'user_rating_delta',
  /** column name */
  UserRatingDescriptionId = 'user_rating_description_id',
  /** column name */
  VarietyName = 'variety_name'
}

/** input type for updating data in table "product_entries" */
export type Product_Entries_Set_Input = {
  batch_id?: Maybe<Scalars['String']>;
  cbc?: Maybe<Scalars['String']>;
  cbd?: Maybe<Scalars['String']>;
  cbda?: Maybe<Scalars['String']>;
  cbg?: Maybe<Scalars['String']>;
  cbn?: Maybe<Scalars['String']>;
  comments_enabled?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  delta8_thc?: Maybe<Scalars['String']>;
  dispensary_id?: Maybe<Scalars['String']>;
  fragrance_type_id?: Maybe<Scalars['String']>;
  harvest_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  origin_state?: Maybe<Scalars['String']>;
  product_entry_id?: Maybe<Scalars['String']>;
  product_type_id?: Maybe<Scalars['String']>;
  strain_id?: Maybe<Scalars['String']>;
  terpene_type_id?: Maybe<Scalars['String']>;
  thc?: Maybe<Scalars['String']>;
  thca?: Maybe<Scalars['String']>;
  thcv?: Maybe<Scalars['String']>;
  track_trace_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating_delta?: Maybe<Scalars['String']>;
  user_rating_description_id?: Maybe<Scalars['String']>;
  variety_name?: Maybe<Scalars['String']>;
};

/** update columns of table "product_entries" */
export enum Product_Entries_Update_Column {
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  Cbc = 'cbc',
  /** column name */
  Cbd = 'cbd',
  /** column name */
  Cbda = 'cbda',
  /** column name */
  Cbg = 'cbg',
  /** column name */
  Cbn = 'cbn',
  /** column name */
  CommentsEnabled = 'comments_enabled',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Delta8Thc = 'delta8_thc',
  /** column name */
  DispensaryId = 'dispensary_id',
  /** column name */
  FragranceTypeId = 'fragrance_type_id',
  /** column name */
  HarvestDate = 'harvest_date',
  /** column name */
  Id = 'id',
  /** column name */
  OriginState = 'origin_state',
  /** column name */
  ProductEntryId = 'product_entry_id',
  /** column name */
  ProductTypeId = 'product_type_id',
  /** column name */
  StrainId = 'strain_id',
  /** column name */
  TerpeneTypeId = 'terpene_type_id',
  /** column name */
  Thc = 'thc',
  /** column name */
  Thca = 'thca',
  /** column name */
  Thcv = 'thcv',
  /** column name */
  TrackTraceId = 'track_trace_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserDescription = 'user_description',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserRatingDelta = 'user_rating_delta',
  /** column name */
  UserRatingDescriptionId = 'user_rating_description_id',
  /** column name */
  VarietyName = 'variety_name'
}

/** columns and relationships of "profiles" */
export type Profiles = {
  __typename?: 'profiles';
  displayName: Scalars['String'];
  dob: Scalars['date'];
  email: Scalars['String'];
  geolocation?: Maybe<Scalars['point']>;
  id: Scalars['uuid'];
  over_21?: Maybe<Scalars['Boolean']>;
  sex?: Maybe<Scalars['String']>;
  user_id: Scalars['String'];
  user_social_facebook?: Maybe<Scalars['String']>;
  user_social_instagram?: Maybe<Scalars['String']>;
  user_social_twitter?: Maybe<Scalars['String']>;
};

/** aggregated selection of "profiles" */
export type Profiles_Aggregate = {
  __typename?: 'profiles_aggregate';
  aggregate?: Maybe<Profiles_Aggregate_Fields>;
  nodes: Array<Profiles>;
};

/** aggregate fields of "profiles" */
export type Profiles_Aggregate_Fields = {
  __typename?: 'profiles_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Profiles_Max_Fields>;
  min?: Maybe<Profiles_Min_Fields>;
};


/** aggregate fields of "profiles" */
export type Profiles_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Profiles_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "profiles" */
export type Profiles_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Profiles_Max_Order_By>;
  min?: Maybe<Profiles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "profiles" */
export type Profiles_Arr_Rel_Insert_Input = {
  data: Array<Profiles_Insert_Input>;
  on_conflict?: Maybe<Profiles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "profiles". All fields are combined with a logical 'AND'. */
export type Profiles_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Profiles_Bool_Exp>>>;
  _not?: Maybe<Profiles_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Profiles_Bool_Exp>>>;
  displayName?: Maybe<String_Comparison_Exp>;
  dob?: Maybe<Date_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  geolocation?: Maybe<Point_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  over_21?: Maybe<Boolean_Comparison_Exp>;
  sex?: Maybe<String_Comparison_Exp>;
  user_id?: Maybe<String_Comparison_Exp>;
  user_social_facebook?: Maybe<String_Comparison_Exp>;
  user_social_instagram?: Maybe<String_Comparison_Exp>;
  user_social_twitter?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "profiles" */
export enum Profiles_Constraint {
  /** unique or primary key constraint */
  ProfilesPkey = 'profiles_pkey',
  /** unique or primary key constraint */
  ProfilesUserIdKey = 'profiles_user_id_key'
}

/** input type for inserting data into table "profiles" */
export type Profiles_Insert_Input = {
  displayName?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['date']>;
  email?: Maybe<Scalars['String']>;
  geolocation?: Maybe<Scalars['point']>;
  id?: Maybe<Scalars['uuid']>;
  over_21?: Maybe<Scalars['Boolean']>;
  sex?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_social_facebook?: Maybe<Scalars['String']>;
  user_social_instagram?: Maybe<Scalars['String']>;
  user_social_twitter?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Profiles_Max_Fields = {
  __typename?: 'profiles_max_fields';
  displayName?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['date']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  sex?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_social_facebook?: Maybe<Scalars['String']>;
  user_social_instagram?: Maybe<Scalars['String']>;
  user_social_twitter?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "profiles" */
export type Profiles_Max_Order_By = {
  displayName?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  sex?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_social_facebook?: Maybe<Order_By>;
  user_social_instagram?: Maybe<Order_By>;
  user_social_twitter?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Profiles_Min_Fields = {
  __typename?: 'profiles_min_fields';
  displayName?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['date']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  sex?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_social_facebook?: Maybe<Scalars['String']>;
  user_social_instagram?: Maybe<Scalars['String']>;
  user_social_twitter?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "profiles" */
export type Profiles_Min_Order_By = {
  displayName?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  sex?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_social_facebook?: Maybe<Order_By>;
  user_social_instagram?: Maybe<Order_By>;
  user_social_twitter?: Maybe<Order_By>;
};

/** response of any mutation on the table "profiles" */
export type Profiles_Mutation_Response = {
  __typename?: 'profiles_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Profiles>;
};

/** input type for inserting object relation for remote table "profiles" */
export type Profiles_Obj_Rel_Insert_Input = {
  data: Profiles_Insert_Input;
  on_conflict?: Maybe<Profiles_On_Conflict>;
};

/** on conflict condition type for table "profiles" */
export type Profiles_On_Conflict = {
  constraint: Profiles_Constraint;
  update_columns: Array<Profiles_Update_Column>;
  where?: Maybe<Profiles_Bool_Exp>;
};

/** ordering options when selecting data from "profiles" */
export type Profiles_Order_By = {
  displayName?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  geolocation?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  over_21?: Maybe<Order_By>;
  sex?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_social_facebook?: Maybe<Order_By>;
  user_social_instagram?: Maybe<Order_By>;
  user_social_twitter?: Maybe<Order_By>;
};

/** primary key columns input for table: "profiles" */
export type Profiles_Pk_Columns_Input = {
  user_id: Scalars['String'];
};

/** select columns of table "profiles" */
export enum Profiles_Select_Column {
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Dob = 'dob',
  /** column name */
  Email = 'email',
  /** column name */
  Geolocation = 'geolocation',
  /** column name */
  Id = 'id',
  /** column name */
  Over_21 = 'over_21',
  /** column name */
  Sex = 'sex',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserSocialFacebook = 'user_social_facebook',
  /** column name */
  UserSocialInstagram = 'user_social_instagram',
  /** column name */
  UserSocialTwitter = 'user_social_twitter'
}

/** input type for updating data in table "profiles" */
export type Profiles_Set_Input = {
  displayName?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['date']>;
  email?: Maybe<Scalars['String']>;
  geolocation?: Maybe<Scalars['point']>;
  id?: Maybe<Scalars['uuid']>;
  over_21?: Maybe<Scalars['Boolean']>;
  sex?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_social_facebook?: Maybe<Scalars['String']>;
  user_social_instagram?: Maybe<Scalars['String']>;
  user_social_twitter?: Maybe<Scalars['String']>;
};

/** update columns of table "profiles" */
export enum Profiles_Update_Column {
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Dob = 'dob',
  /** column name */
  Email = 'email',
  /** column name */
  Geolocation = 'geolocation',
  /** column name */
  Id = 'id',
  /** column name */
  Over_21 = 'over_21',
  /** column name */
  Sex = 'sex',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserSocialFacebook = 'user_social_facebook',
  /** column name */
  UserSocialInstagram = 'user_social_instagram',
  /** column name */
  UserSocialTwitter = 'user_social_twitter'
}

/** query root */
export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "consumption_enteries" */
  consumption_enteries: Array<Consumption_Enteries>;
  /** fetch aggregated fields from the table: "consumption_enteries" */
  consumption_enteries_aggregate: Consumption_Enteries_Aggregate;
  /** fetch data from the table: "consumption_enteries" using primary key columns */
  consumption_enteries_by_pk?: Maybe<Consumption_Enteries>;
  /** fetch data from the table: "consumption_types" */
  consumption_types: Array<Consumption_Types>;
  /** fetch aggregated fields from the table: "consumption_types" */
  consumption_types_aggregate: Consumption_Types_Aggregate;
  /** fetch data from the table: "consumption_types" using primary key columns */
  consumption_types_by_pk?: Maybe<Consumption_Types>;
  /** fetch data from the table: "entries" */
  entries: Array<Entries>;
  /** fetch aggregated fields from the table: "entries" */
  entries_aggregate: Entries_Aggregate;
  /** fetch data from the table: "entries" using primary key columns */
  entries_by_pk?: Maybe<Entries>;
  /** fetch data from the table: "product_entries" */
  product_entries: Array<Product_Entries>;
  /** fetch aggregated fields from the table: "product_entries" */
  product_entries_aggregate: Product_Entries_Aggregate;
  /** fetch data from the table: "product_entries" using primary key columns */
  product_entries_by_pk?: Maybe<Product_Entries>;
  /** fetch data from the table: "profiles" */
  profiles: Array<Profiles>;
  /** fetch aggregated fields from the table: "profiles" */
  profiles_aggregate: Profiles_Aggregate;
  /** fetch data from the table: "profiles" using primary key columns */
  profiles_by_pk?: Maybe<Profiles>;
  /** fetch data from the table: "strains" */
  strains: Array<Strains>;
  /** fetch aggregated fields from the table: "strains" */
  strains_aggregate: Strains_Aggregate;
  /** fetch data from the table: "strains" using primary key columns */
  strains_by_pk?: Maybe<Strains>;
  /** fetch data from the table: "user_profiles" */
  user_profiles: Array<User_Profiles>;
  /** fetch aggregated fields from the table: "user_profiles" */
  user_profiles_aggregate: User_Profiles_Aggregate;
  /** fetch data from the table: "user_profiles" using primary key columns */
  user_profiles_by_pk?: Maybe<User_Profiles>;
  /** fetch data from the table: "user_ratings" */
  user_ratings: Array<User_Ratings>;
  /** fetch aggregated fields from the table: "user_ratings" */
  user_ratings_aggregate: User_Ratings_Aggregate;
  /** fetch data from the table: "user_ratings" using primary key columns */
  user_ratings_by_pk?: Maybe<User_Ratings>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


/** query root */
export type Query_RootConsumption_EnteriesArgs = {
  distinct_on?: Maybe<Array<Consumption_Enteries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Consumption_Enteries_Order_By>>;
  where?: Maybe<Consumption_Enteries_Bool_Exp>;
};


/** query root */
export type Query_RootConsumption_Enteries_AggregateArgs = {
  distinct_on?: Maybe<Array<Consumption_Enteries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Consumption_Enteries_Order_By>>;
  where?: Maybe<Consumption_Enteries_Bool_Exp>;
};


/** query root */
export type Query_RootConsumption_Enteries_By_PkArgs = {
  consumption_entry_id: Scalars['String'];
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootConsumption_TypesArgs = {
  distinct_on?: Maybe<Array<Consumption_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Consumption_Types_Order_By>>;
  where?: Maybe<Consumption_Types_Bool_Exp>;
};


/** query root */
export type Query_RootConsumption_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Consumption_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Consumption_Types_Order_By>>;
  where?: Maybe<Consumption_Types_Bool_Exp>;
};


/** query root */
export type Query_RootConsumption_Types_By_PkArgs = {
  consumption_id: Scalars['uuid'];
};


/** query root */
export type Query_RootEntriesArgs = {
  distinct_on?: Maybe<Array<Entries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Entries_Order_By>>;
  where?: Maybe<Entries_Bool_Exp>;
};


/** query root */
export type Query_RootEntries_AggregateArgs = {
  distinct_on?: Maybe<Array<Entries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Entries_Order_By>>;
  where?: Maybe<Entries_Bool_Exp>;
};


/** query root */
export type Query_RootEntries_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootProduct_EntriesArgs = {
  distinct_on?: Maybe<Array<Product_Entries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Product_Entries_Order_By>>;
  where?: Maybe<Product_Entries_Bool_Exp>;
};


/** query root */
export type Query_RootProduct_Entries_AggregateArgs = {
  distinct_on?: Maybe<Array<Product_Entries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Product_Entries_Order_By>>;
  where?: Maybe<Product_Entries_Bool_Exp>;
};


/** query root */
export type Query_RootProduct_Entries_By_PkArgs = {
  product_entry_id: Scalars['String'];
};


/** query root */
export type Query_RootProfilesArgs = {
  distinct_on?: Maybe<Array<Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profiles_Order_By>>;
  where?: Maybe<Profiles_Bool_Exp>;
};


/** query root */
export type Query_RootProfiles_AggregateArgs = {
  distinct_on?: Maybe<Array<Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profiles_Order_By>>;
  where?: Maybe<Profiles_Bool_Exp>;
};


/** query root */
export type Query_RootProfiles_By_PkArgs = {
  user_id: Scalars['String'];
};


/** query root */
export type Query_RootStrainsArgs = {
  distinct_on?: Maybe<Array<Strains_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Strains_Order_By>>;
  where?: Maybe<Strains_Bool_Exp>;
};


/** query root */
export type Query_RootStrains_AggregateArgs = {
  distinct_on?: Maybe<Array<Strains_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Strains_Order_By>>;
  where?: Maybe<Strains_Bool_Exp>;
};


/** query root */
export type Query_RootStrains_By_PkArgs = {
  id: Scalars['String'];
};


/** query root */
export type Query_RootUser_ProfilesArgs = {
  distinct_on?: Maybe<Array<User_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profiles_Order_By>>;
  where?: Maybe<User_Profiles_Bool_Exp>;
};


/** query root */
export type Query_RootUser_Profiles_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profiles_Order_By>>;
  where?: Maybe<User_Profiles_Bool_Exp>;
};


/** query root */
export type Query_RootUser_Profiles_By_PkArgs = {
  user_id: Scalars['String'];
};


/** query root */
export type Query_RootUser_RatingsArgs = {
  distinct_on?: Maybe<Array<User_Ratings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Ratings_Order_By>>;
  where?: Maybe<User_Ratings_Bool_Exp>;
};


/** query root */
export type Query_RootUser_Ratings_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Ratings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Ratings_Order_By>>;
  where?: Maybe<User_Ratings_Bool_Exp>;
};


/** query root */
export type Query_RootUser_Ratings_By_PkArgs = {
  user_rating_id: Scalars['String'];
};


/** query root */
export type Query_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** query root */
export type Query_RootUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** query root */
export type Query_RootUsers_By_PkArgs = {
  id: Scalars['String'];
};

/** columns and relationships of "strains" */
export type Strains = {
  __typename?: 'strains';
  id: Scalars['String'];
  initial_consumption_type: Scalars['String'];
  strain_name: Scalars['String'];
  strain_type: Scalars['String'];
  strains_type: Scalars['String'];
};

/** aggregated selection of "strains" */
export type Strains_Aggregate = {
  __typename?: 'strains_aggregate';
  aggregate?: Maybe<Strains_Aggregate_Fields>;
  nodes: Array<Strains>;
};

/** aggregate fields of "strains" */
export type Strains_Aggregate_Fields = {
  __typename?: 'strains_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Strains_Max_Fields>;
  min?: Maybe<Strains_Min_Fields>;
};


/** aggregate fields of "strains" */
export type Strains_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Strains_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "strains" */
export type Strains_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Strains_Max_Order_By>;
  min?: Maybe<Strains_Min_Order_By>;
};

/** input type for inserting array relation for remote table "strains" */
export type Strains_Arr_Rel_Insert_Input = {
  data: Array<Strains_Insert_Input>;
  on_conflict?: Maybe<Strains_On_Conflict>;
};

/** Boolean expression to filter rows from the table "strains". All fields are combined with a logical 'AND'. */
export type Strains_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Strains_Bool_Exp>>>;
  _not?: Maybe<Strains_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Strains_Bool_Exp>>>;
  id?: Maybe<String_Comparison_Exp>;
  initial_consumption_type?: Maybe<String_Comparison_Exp>;
  strain_name?: Maybe<String_Comparison_Exp>;
  strain_type?: Maybe<String_Comparison_Exp>;
  strains_type?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "strains" */
export enum Strains_Constraint {
  /** unique or primary key constraint */
  StrainsPkey = 'strains_pkey'
}

/** input type for inserting data into table "strains" */
export type Strains_Insert_Input = {
  id?: Maybe<Scalars['String']>;
  initial_consumption_type?: Maybe<Scalars['String']>;
  strain_name?: Maybe<Scalars['String']>;
  strain_type?: Maybe<Scalars['String']>;
  strains_type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Strains_Max_Fields = {
  __typename?: 'strains_max_fields';
  id?: Maybe<Scalars['String']>;
  initial_consumption_type?: Maybe<Scalars['String']>;
  strain_name?: Maybe<Scalars['String']>;
  strain_type?: Maybe<Scalars['String']>;
  strains_type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "strains" */
export type Strains_Max_Order_By = {
  id?: Maybe<Order_By>;
  initial_consumption_type?: Maybe<Order_By>;
  strain_name?: Maybe<Order_By>;
  strain_type?: Maybe<Order_By>;
  strains_type?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Strains_Min_Fields = {
  __typename?: 'strains_min_fields';
  id?: Maybe<Scalars['String']>;
  initial_consumption_type?: Maybe<Scalars['String']>;
  strain_name?: Maybe<Scalars['String']>;
  strain_type?: Maybe<Scalars['String']>;
  strains_type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "strains" */
export type Strains_Min_Order_By = {
  id?: Maybe<Order_By>;
  initial_consumption_type?: Maybe<Order_By>;
  strain_name?: Maybe<Order_By>;
  strain_type?: Maybe<Order_By>;
  strains_type?: Maybe<Order_By>;
};

/** response of any mutation on the table "strains" */
export type Strains_Mutation_Response = {
  __typename?: 'strains_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Strains>;
};

/** input type for inserting object relation for remote table "strains" */
export type Strains_Obj_Rel_Insert_Input = {
  data: Strains_Insert_Input;
  on_conflict?: Maybe<Strains_On_Conflict>;
};

/** on conflict condition type for table "strains" */
export type Strains_On_Conflict = {
  constraint: Strains_Constraint;
  update_columns: Array<Strains_Update_Column>;
  where?: Maybe<Strains_Bool_Exp>;
};

/** ordering options when selecting data from "strains" */
export type Strains_Order_By = {
  id?: Maybe<Order_By>;
  initial_consumption_type?: Maybe<Order_By>;
  strain_name?: Maybe<Order_By>;
  strain_type?: Maybe<Order_By>;
  strains_type?: Maybe<Order_By>;
};

/** primary key columns input for table: "strains" */
export type Strains_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "strains" */
export enum Strains_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InitialConsumptionType = 'initial_consumption_type',
  /** column name */
  StrainName = 'strain_name',
  /** column name */
  StrainType = 'strain_type',
  /** column name */
  StrainsType = 'strains_type'
}

/** input type for updating data in table "strains" */
export type Strains_Set_Input = {
  id?: Maybe<Scalars['String']>;
  initial_consumption_type?: Maybe<Scalars['String']>;
  strain_name?: Maybe<Scalars['String']>;
  strain_type?: Maybe<Scalars['String']>;
  strains_type?: Maybe<Scalars['String']>;
};

/** update columns of table "strains" */
export enum Strains_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InitialConsumptionType = 'initial_consumption_type',
  /** column name */
  StrainName = 'strain_name',
  /** column name */
  StrainType = 'strain_type',
  /** column name */
  StrainsType = 'strains_type'
}

/** subscription root */
export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "consumption_enteries" */
  consumption_enteries: Array<Consumption_Enteries>;
  /** fetch aggregated fields from the table: "consumption_enteries" */
  consumption_enteries_aggregate: Consumption_Enteries_Aggregate;
  /** fetch data from the table: "consumption_enteries" using primary key columns */
  consumption_enteries_by_pk?: Maybe<Consumption_Enteries>;
  /** fetch data from the table: "consumption_types" */
  consumption_types: Array<Consumption_Types>;
  /** fetch aggregated fields from the table: "consumption_types" */
  consumption_types_aggregate: Consumption_Types_Aggregate;
  /** fetch data from the table: "consumption_types" using primary key columns */
  consumption_types_by_pk?: Maybe<Consumption_Types>;
  /** fetch data from the table: "entries" */
  entries: Array<Entries>;
  /** fetch aggregated fields from the table: "entries" */
  entries_aggregate: Entries_Aggregate;
  /** fetch data from the table: "entries" using primary key columns */
  entries_by_pk?: Maybe<Entries>;
  /** fetch data from the table: "product_entries" */
  product_entries: Array<Product_Entries>;
  /** fetch aggregated fields from the table: "product_entries" */
  product_entries_aggregate: Product_Entries_Aggregate;
  /** fetch data from the table: "product_entries" using primary key columns */
  product_entries_by_pk?: Maybe<Product_Entries>;
  /** fetch data from the table: "profiles" */
  profiles: Array<Profiles>;
  /** fetch aggregated fields from the table: "profiles" */
  profiles_aggregate: Profiles_Aggregate;
  /** fetch data from the table: "profiles" using primary key columns */
  profiles_by_pk?: Maybe<Profiles>;
  /** fetch data from the table: "strains" */
  strains: Array<Strains>;
  /** fetch aggregated fields from the table: "strains" */
  strains_aggregate: Strains_Aggregate;
  /** fetch data from the table: "strains" using primary key columns */
  strains_by_pk?: Maybe<Strains>;
  /** fetch data from the table: "user_profiles" */
  user_profiles: Array<User_Profiles>;
  /** fetch aggregated fields from the table: "user_profiles" */
  user_profiles_aggregate: User_Profiles_Aggregate;
  /** fetch data from the table: "user_profiles" using primary key columns */
  user_profiles_by_pk?: Maybe<User_Profiles>;
  /** fetch data from the table: "user_ratings" */
  user_ratings: Array<User_Ratings>;
  /** fetch aggregated fields from the table: "user_ratings" */
  user_ratings_aggregate: User_Ratings_Aggregate;
  /** fetch data from the table: "user_ratings" using primary key columns */
  user_ratings_by_pk?: Maybe<User_Ratings>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


/** subscription root */
export type Subscription_RootConsumption_EnteriesArgs = {
  distinct_on?: Maybe<Array<Consumption_Enteries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Consumption_Enteries_Order_By>>;
  where?: Maybe<Consumption_Enteries_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootConsumption_Enteries_AggregateArgs = {
  distinct_on?: Maybe<Array<Consumption_Enteries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Consumption_Enteries_Order_By>>;
  where?: Maybe<Consumption_Enteries_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootConsumption_Enteries_By_PkArgs = {
  consumption_entry_id: Scalars['String'];
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootConsumption_TypesArgs = {
  distinct_on?: Maybe<Array<Consumption_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Consumption_Types_Order_By>>;
  where?: Maybe<Consumption_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootConsumption_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Consumption_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Consumption_Types_Order_By>>;
  where?: Maybe<Consumption_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootConsumption_Types_By_PkArgs = {
  consumption_id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootEntriesArgs = {
  distinct_on?: Maybe<Array<Entries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Entries_Order_By>>;
  where?: Maybe<Entries_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEntries_AggregateArgs = {
  distinct_on?: Maybe<Array<Entries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Entries_Order_By>>;
  where?: Maybe<Entries_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEntries_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootProduct_EntriesArgs = {
  distinct_on?: Maybe<Array<Product_Entries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Product_Entries_Order_By>>;
  where?: Maybe<Product_Entries_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootProduct_Entries_AggregateArgs = {
  distinct_on?: Maybe<Array<Product_Entries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Product_Entries_Order_By>>;
  where?: Maybe<Product_Entries_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootProduct_Entries_By_PkArgs = {
  product_entry_id: Scalars['String'];
};


/** subscription root */
export type Subscription_RootProfilesArgs = {
  distinct_on?: Maybe<Array<Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profiles_Order_By>>;
  where?: Maybe<Profiles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootProfiles_AggregateArgs = {
  distinct_on?: Maybe<Array<Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profiles_Order_By>>;
  where?: Maybe<Profiles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootProfiles_By_PkArgs = {
  user_id: Scalars['String'];
};


/** subscription root */
export type Subscription_RootStrainsArgs = {
  distinct_on?: Maybe<Array<Strains_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Strains_Order_By>>;
  where?: Maybe<Strains_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootStrains_AggregateArgs = {
  distinct_on?: Maybe<Array<Strains_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Strains_Order_By>>;
  where?: Maybe<Strains_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootStrains_By_PkArgs = {
  id: Scalars['String'];
};


/** subscription root */
export type Subscription_RootUser_ProfilesArgs = {
  distinct_on?: Maybe<Array<User_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profiles_Order_By>>;
  where?: Maybe<User_Profiles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUser_Profiles_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profiles_Order_By>>;
  where?: Maybe<User_Profiles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUser_Profiles_By_PkArgs = {
  user_id: Scalars['String'];
};


/** subscription root */
export type Subscription_RootUser_RatingsArgs = {
  distinct_on?: Maybe<Array<User_Ratings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Ratings_Order_By>>;
  where?: Maybe<User_Ratings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUser_Ratings_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Ratings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Ratings_Order_By>>;
  where?: Maybe<User_Ratings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUser_Ratings_By_PkArgs = {
  user_rating_id: Scalars['String'];
};


/** subscription root */
export type Subscription_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['String'];
};


/** expression to compare columns of type timestamptz. All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "user_profiles" */
export type User_Profiles = {
  __typename?: 'user_profiles';
  display_name: Scalars['String'];
  dob?: Maybe<Scalars['String']>;
  enable_comments?: Maybe<Scalars['Boolean']>;
  favorite_varieties?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  last_name?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  social_fb?: Maybe<Scalars['String']>;
  social_ig?: Maybe<Scalars['String']>;
  social_tw?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  total_enteries?: Maybe<Scalars['String']>;
  user_id: Scalars['String'];
  user_long_bio?: Maybe<Scalars['String']>;
  user_short_bio?: Maybe<Scalars['String']>;
};

/** aggregated selection of "user_profiles" */
export type User_Profiles_Aggregate = {
  __typename?: 'user_profiles_aggregate';
  aggregate?: Maybe<User_Profiles_Aggregate_Fields>;
  nodes: Array<User_Profiles>;
};

/** aggregate fields of "user_profiles" */
export type User_Profiles_Aggregate_Fields = {
  __typename?: 'user_profiles_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<User_Profiles_Max_Fields>;
  min?: Maybe<User_Profiles_Min_Fields>;
};


/** aggregate fields of "user_profiles" */
export type User_Profiles_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Profiles_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_profiles" */
export type User_Profiles_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<User_Profiles_Max_Order_By>;
  min?: Maybe<User_Profiles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_profiles" */
export type User_Profiles_Arr_Rel_Insert_Input = {
  data: Array<User_Profiles_Insert_Input>;
  on_conflict?: Maybe<User_Profiles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_profiles". All fields are combined with a logical 'AND'. */
export type User_Profiles_Bool_Exp = {
  _and?: Maybe<Array<Maybe<User_Profiles_Bool_Exp>>>;
  _not?: Maybe<User_Profiles_Bool_Exp>;
  _or?: Maybe<Array<Maybe<User_Profiles_Bool_Exp>>>;
  display_name?: Maybe<String_Comparison_Exp>;
  dob?: Maybe<String_Comparison_Exp>;
  enable_comments?: Maybe<Boolean_Comparison_Exp>;
  favorite_varieties?: Maybe<String_Comparison_Exp>;
  first_name?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  last_name?: Maybe<String_Comparison_Exp>;
  profile_picture?: Maybe<String_Comparison_Exp>;
  sex?: Maybe<String_Comparison_Exp>;
  social_fb?: Maybe<String_Comparison_Exp>;
  social_ig?: Maybe<String_Comparison_Exp>;
  social_tw?: Maybe<String_Comparison_Exp>;
  state?: Maybe<String_Comparison_Exp>;
  total_enteries?: Maybe<String_Comparison_Exp>;
  user_id?: Maybe<String_Comparison_Exp>;
  user_long_bio?: Maybe<String_Comparison_Exp>;
  user_short_bio?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_profiles" */
export enum User_Profiles_Constraint {
  /** unique or primary key constraint */
  UserProfilesIdKey = 'user_profiles_id_key',
  /** unique or primary key constraint */
  UserProfilesPkey = 'user_profiles_pkey'
}

/** input type for inserting data into table "user_profiles" */
export type User_Profiles_Insert_Input = {
  display_name?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  enable_comments?: Maybe<Scalars['Boolean']>;
  favorite_varieties?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  social_fb?: Maybe<Scalars['String']>;
  social_ig?: Maybe<Scalars['String']>;
  social_tw?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  total_enteries?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_long_bio?: Maybe<Scalars['String']>;
  user_short_bio?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Profiles_Max_Fields = {
  __typename?: 'user_profiles_max_fields';
  display_name?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  favorite_varieties?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  social_fb?: Maybe<Scalars['String']>;
  social_ig?: Maybe<Scalars['String']>;
  social_tw?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  total_enteries?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_long_bio?: Maybe<Scalars['String']>;
  user_short_bio?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_profiles" */
export type User_Profiles_Max_Order_By = {
  display_name?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  favorite_varieties?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  profile_picture?: Maybe<Order_By>;
  sex?: Maybe<Order_By>;
  social_fb?: Maybe<Order_By>;
  social_ig?: Maybe<Order_By>;
  social_tw?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  total_enteries?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_long_bio?: Maybe<Order_By>;
  user_short_bio?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Profiles_Min_Fields = {
  __typename?: 'user_profiles_min_fields';
  display_name?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  favorite_varieties?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  social_fb?: Maybe<Scalars['String']>;
  social_ig?: Maybe<Scalars['String']>;
  social_tw?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  total_enteries?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_long_bio?: Maybe<Scalars['String']>;
  user_short_bio?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_profiles" */
export type User_Profiles_Min_Order_By = {
  display_name?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  favorite_varieties?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  profile_picture?: Maybe<Order_By>;
  sex?: Maybe<Order_By>;
  social_fb?: Maybe<Order_By>;
  social_ig?: Maybe<Order_By>;
  social_tw?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  total_enteries?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_long_bio?: Maybe<Order_By>;
  user_short_bio?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_profiles" */
export type User_Profiles_Mutation_Response = {
  __typename?: 'user_profiles_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<User_Profiles>;
};

/** input type for inserting object relation for remote table "user_profiles" */
export type User_Profiles_Obj_Rel_Insert_Input = {
  data: User_Profiles_Insert_Input;
  on_conflict?: Maybe<User_Profiles_On_Conflict>;
};

/** on conflict condition type for table "user_profiles" */
export type User_Profiles_On_Conflict = {
  constraint: User_Profiles_Constraint;
  update_columns: Array<User_Profiles_Update_Column>;
  where?: Maybe<User_Profiles_Bool_Exp>;
};

/** ordering options when selecting data from "user_profiles" */
export type User_Profiles_Order_By = {
  display_name?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  enable_comments?: Maybe<Order_By>;
  favorite_varieties?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  profile_picture?: Maybe<Order_By>;
  sex?: Maybe<Order_By>;
  social_fb?: Maybe<Order_By>;
  social_ig?: Maybe<Order_By>;
  social_tw?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  total_enteries?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_long_bio?: Maybe<Order_By>;
  user_short_bio?: Maybe<Order_By>;
};

/** primary key columns input for table: "user_profiles" */
export type User_Profiles_Pk_Columns_Input = {
  user_id: Scalars['String'];
};

/** select columns of table "user_profiles" */
export enum User_Profiles_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Dob = 'dob',
  /** column name */
  EnableComments = 'enable_comments',
  /** column name */
  FavoriteVarieties = 'favorite_varieties',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  ProfilePicture = 'profile_picture',
  /** column name */
  Sex = 'sex',
  /** column name */
  SocialFb = 'social_fb',
  /** column name */
  SocialIg = 'social_ig',
  /** column name */
  SocialTw = 'social_tw',
  /** column name */
  State = 'state',
  /** column name */
  TotalEnteries = 'total_enteries',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserLongBio = 'user_long_bio',
  /** column name */
  UserShortBio = 'user_short_bio'
}

/** input type for updating data in table "user_profiles" */
export type User_Profiles_Set_Input = {
  display_name?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  enable_comments?: Maybe<Scalars['Boolean']>;
  favorite_varieties?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  social_fb?: Maybe<Scalars['String']>;
  social_ig?: Maybe<Scalars['String']>;
  social_tw?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  total_enteries?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_long_bio?: Maybe<Scalars['String']>;
  user_short_bio?: Maybe<Scalars['String']>;
};

/** update columns of table "user_profiles" */
export enum User_Profiles_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Dob = 'dob',
  /** column name */
  EnableComments = 'enable_comments',
  /** column name */
  FavoriteVarieties = 'favorite_varieties',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  ProfilePicture = 'profile_picture',
  /** column name */
  Sex = 'sex',
  /** column name */
  SocialFb = 'social_fb',
  /** column name */
  SocialIg = 'social_ig',
  /** column name */
  SocialTw = 'social_tw',
  /** column name */
  State = 'state',
  /** column name */
  TotalEnteries = 'total_enteries',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserLongBio = 'user_long_bio',
  /** column name */
  UserShortBio = 'user_short_bio'
}

/** columns and relationships of "user_ratings" */
export type User_Ratings = {
  __typename?: 'user_ratings';
  id: Scalars['uuid'];
  rating_after_1: Scalars['String'];
  rating_after_2: Scalars['String'];
  rating_after_3: Scalars['String'];
  rating_after_4: Scalars['String'];
  rating_after_5: Scalars['String'];
  rating_before_1: Scalars['String'];
  rating_before_2: Scalars['String'];
  rating_before_3: Scalars['String'];
  rating_before_4: Scalars['String'];
  rating_before_5: Scalars['String'];
  strain_id?: Maybe<Scalars['String']>;
  user_id: Scalars['String'];
  user_rating_id: Scalars['String'];
};

/** aggregated selection of "user_ratings" */
export type User_Ratings_Aggregate = {
  __typename?: 'user_ratings_aggregate';
  aggregate?: Maybe<User_Ratings_Aggregate_Fields>;
  nodes: Array<User_Ratings>;
};

/** aggregate fields of "user_ratings" */
export type User_Ratings_Aggregate_Fields = {
  __typename?: 'user_ratings_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<User_Ratings_Max_Fields>;
  min?: Maybe<User_Ratings_Min_Fields>;
};


/** aggregate fields of "user_ratings" */
export type User_Ratings_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Ratings_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_ratings" */
export type User_Ratings_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<User_Ratings_Max_Order_By>;
  min?: Maybe<User_Ratings_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_ratings" */
export type User_Ratings_Arr_Rel_Insert_Input = {
  data: Array<User_Ratings_Insert_Input>;
  on_conflict?: Maybe<User_Ratings_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_ratings". All fields are combined with a logical 'AND'. */
export type User_Ratings_Bool_Exp = {
  _and?: Maybe<Array<Maybe<User_Ratings_Bool_Exp>>>;
  _not?: Maybe<User_Ratings_Bool_Exp>;
  _or?: Maybe<Array<Maybe<User_Ratings_Bool_Exp>>>;
  id?: Maybe<Uuid_Comparison_Exp>;
  rating_after_1?: Maybe<String_Comparison_Exp>;
  rating_after_2?: Maybe<String_Comparison_Exp>;
  rating_after_3?: Maybe<String_Comparison_Exp>;
  rating_after_4?: Maybe<String_Comparison_Exp>;
  rating_after_5?: Maybe<String_Comparison_Exp>;
  rating_before_1?: Maybe<String_Comparison_Exp>;
  rating_before_2?: Maybe<String_Comparison_Exp>;
  rating_before_3?: Maybe<String_Comparison_Exp>;
  rating_before_4?: Maybe<String_Comparison_Exp>;
  rating_before_5?: Maybe<String_Comparison_Exp>;
  strain_id?: Maybe<String_Comparison_Exp>;
  user_id?: Maybe<String_Comparison_Exp>;
  user_rating_id?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_ratings" */
export enum User_Ratings_Constraint {
  /** unique or primary key constraint */
  UserRatingsIdKey = 'user_ratings_id_key',
  /** unique or primary key constraint */
  UserRatingsPkey = 'user_ratings_pkey'
}

/** input type for inserting data into table "user_ratings" */
export type User_Ratings_Insert_Input = {
  id?: Maybe<Scalars['uuid']>;
  rating_after_1?: Maybe<Scalars['String']>;
  rating_after_2?: Maybe<Scalars['String']>;
  rating_after_3?: Maybe<Scalars['String']>;
  rating_after_4?: Maybe<Scalars['String']>;
  rating_after_5?: Maybe<Scalars['String']>;
  rating_before_1?: Maybe<Scalars['String']>;
  rating_before_2?: Maybe<Scalars['String']>;
  rating_before_3?: Maybe<Scalars['String']>;
  rating_before_4?: Maybe<Scalars['String']>;
  rating_before_5?: Maybe<Scalars['String']>;
  strain_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Ratings_Max_Fields = {
  __typename?: 'user_ratings_max_fields';
  id?: Maybe<Scalars['uuid']>;
  rating_after_1?: Maybe<Scalars['String']>;
  rating_after_2?: Maybe<Scalars['String']>;
  rating_after_3?: Maybe<Scalars['String']>;
  rating_after_4?: Maybe<Scalars['String']>;
  rating_after_5?: Maybe<Scalars['String']>;
  rating_before_1?: Maybe<Scalars['String']>;
  rating_before_2?: Maybe<Scalars['String']>;
  rating_before_3?: Maybe<Scalars['String']>;
  rating_before_4?: Maybe<Scalars['String']>;
  rating_before_5?: Maybe<Scalars['String']>;
  strain_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_ratings" */
export type User_Ratings_Max_Order_By = {
  id?: Maybe<Order_By>;
  rating_after_1?: Maybe<Order_By>;
  rating_after_2?: Maybe<Order_By>;
  rating_after_3?: Maybe<Order_By>;
  rating_after_4?: Maybe<Order_By>;
  rating_after_5?: Maybe<Order_By>;
  rating_before_1?: Maybe<Order_By>;
  rating_before_2?: Maybe<Order_By>;
  rating_before_3?: Maybe<Order_By>;
  rating_before_4?: Maybe<Order_By>;
  rating_before_5?: Maybe<Order_By>;
  strain_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_rating_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Ratings_Min_Fields = {
  __typename?: 'user_ratings_min_fields';
  id?: Maybe<Scalars['uuid']>;
  rating_after_1?: Maybe<Scalars['String']>;
  rating_after_2?: Maybe<Scalars['String']>;
  rating_after_3?: Maybe<Scalars['String']>;
  rating_after_4?: Maybe<Scalars['String']>;
  rating_after_5?: Maybe<Scalars['String']>;
  rating_before_1?: Maybe<Scalars['String']>;
  rating_before_2?: Maybe<Scalars['String']>;
  rating_before_3?: Maybe<Scalars['String']>;
  rating_before_4?: Maybe<Scalars['String']>;
  rating_before_5?: Maybe<Scalars['String']>;
  strain_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_ratings" */
export type User_Ratings_Min_Order_By = {
  id?: Maybe<Order_By>;
  rating_after_1?: Maybe<Order_By>;
  rating_after_2?: Maybe<Order_By>;
  rating_after_3?: Maybe<Order_By>;
  rating_after_4?: Maybe<Order_By>;
  rating_after_5?: Maybe<Order_By>;
  rating_before_1?: Maybe<Order_By>;
  rating_before_2?: Maybe<Order_By>;
  rating_before_3?: Maybe<Order_By>;
  rating_before_4?: Maybe<Order_By>;
  rating_before_5?: Maybe<Order_By>;
  strain_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_rating_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_ratings" */
export type User_Ratings_Mutation_Response = {
  __typename?: 'user_ratings_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<User_Ratings>;
};

/** input type for inserting object relation for remote table "user_ratings" */
export type User_Ratings_Obj_Rel_Insert_Input = {
  data: User_Ratings_Insert_Input;
  on_conflict?: Maybe<User_Ratings_On_Conflict>;
};

/** on conflict condition type for table "user_ratings" */
export type User_Ratings_On_Conflict = {
  constraint: User_Ratings_Constraint;
  update_columns: Array<User_Ratings_Update_Column>;
  where?: Maybe<User_Ratings_Bool_Exp>;
};

/** ordering options when selecting data from "user_ratings" */
export type User_Ratings_Order_By = {
  id?: Maybe<Order_By>;
  rating_after_1?: Maybe<Order_By>;
  rating_after_2?: Maybe<Order_By>;
  rating_after_3?: Maybe<Order_By>;
  rating_after_4?: Maybe<Order_By>;
  rating_after_5?: Maybe<Order_By>;
  rating_before_1?: Maybe<Order_By>;
  rating_before_2?: Maybe<Order_By>;
  rating_before_3?: Maybe<Order_By>;
  rating_before_4?: Maybe<Order_By>;
  rating_before_5?: Maybe<Order_By>;
  strain_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_rating_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "user_ratings" */
export type User_Ratings_Pk_Columns_Input = {
  user_rating_id: Scalars['String'];
};

/** select columns of table "user_ratings" */
export enum User_Ratings_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RatingAfter_1 = 'rating_after_1',
  /** column name */
  RatingAfter_2 = 'rating_after_2',
  /** column name */
  RatingAfter_3 = 'rating_after_3',
  /** column name */
  RatingAfter_4 = 'rating_after_4',
  /** column name */
  RatingAfter_5 = 'rating_after_5',
  /** column name */
  RatingBefore_1 = 'rating_before_1',
  /** column name */
  RatingBefore_2 = 'rating_before_2',
  /** column name */
  RatingBefore_3 = 'rating_before_3',
  /** column name */
  RatingBefore_4 = 'rating_before_4',
  /** column name */
  RatingBefore_5 = 'rating_before_5',
  /** column name */
  StrainId = 'strain_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserRatingId = 'user_rating_id'
}

/** input type for updating data in table "user_ratings" */
export type User_Ratings_Set_Input = {
  id?: Maybe<Scalars['uuid']>;
  rating_after_1?: Maybe<Scalars['String']>;
  rating_after_2?: Maybe<Scalars['String']>;
  rating_after_3?: Maybe<Scalars['String']>;
  rating_after_4?: Maybe<Scalars['String']>;
  rating_after_5?: Maybe<Scalars['String']>;
  rating_before_1?: Maybe<Scalars['String']>;
  rating_before_2?: Maybe<Scalars['String']>;
  rating_before_3?: Maybe<Scalars['String']>;
  rating_before_4?: Maybe<Scalars['String']>;
  rating_before_5?: Maybe<Scalars['String']>;
  strain_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_rating_id?: Maybe<Scalars['String']>;
};

/** update columns of table "user_ratings" */
export enum User_Ratings_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RatingAfter_1 = 'rating_after_1',
  /** column name */
  RatingAfter_2 = 'rating_after_2',
  /** column name */
  RatingAfter_3 = 'rating_after_3',
  /** column name */
  RatingAfter_4 = 'rating_after_4',
  /** column name */
  RatingAfter_5 = 'rating_after_5',
  /** column name */
  RatingBefore_1 = 'rating_before_1',
  /** column name */
  RatingBefore_2 = 'rating_before_2',
  /** column name */
  RatingBefore_3 = 'rating_before_3',
  /** column name */
  RatingBefore_4 = 'rating_before_4',
  /** column name */
  RatingBefore_5 = 'rating_before_5',
  /** column name */
  StrainId = 'strain_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserRatingId = 'user_rating_id'
}

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  address?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Users_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Users_Max_Order_By>;
  min?: Maybe<Users_Min_Order_By>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  on_conflict?: Maybe<Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Users_Bool_Exp>>>;
  _not?: Maybe<Users_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Users_Bool_Exp>>>;
  address?: Maybe<String_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  id?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint */
  UsersPkey = 'users_pkey'
}

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  address?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  address?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  address?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  address?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  address?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  on_conflict?: Maybe<Users_On_Conflict>;
};

/** on conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns: Array<Users_Update_Column>;
  where?: Maybe<Users_Bool_Exp>;
};

/** ordering options when selecting data from "users" */
export type Users_Order_By = {
  address?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
};

/** primary key columns input for table: "users" */
export type Users_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  address?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}


/** expression to compare columns of type uuid. All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};

export type GetConsumptionEntriesQueryVariables = Exact<{
  productEntryId: Scalars['String'];
}>;


export type GetConsumptionEntriesQuery = (
  { __typename?: 'query_root' }
  & { consumption_enteries: Array<(
    { __typename?: 'consumption_enteries' }
    & Pick<Consumption_Enteries, 'product_entry_id' | 'consumption_type_id' | 'user_id' | 'user_description' | 'user_rating' | 'rating_1_before' | 'rating_2_before' | 'rating_3_before' | 'rating_4_before' | 'rating_5_before' | 'rating_6_before' | 'rating_7_before' | 'rating_8_before' | 'rating_9_before' | 'rating_10_before' | 'rating_1_after' | 'rating_2_after' | 'rating_3_after' | 'rating_4_after' | 'rating_5_after' | 'rating_6_after' | 'rating_7_after' | 'rating_8_after' | 'rating_9_after' | 'rating_10_after' | 'rating_1_question_id' | 'rating_2_question_id' | 'rating_3_question_id' | 'rating_4_question_id' | 'rating_5_question_id' | 'rating_6_question_id' | 'rating_7_question_id' | 'rating_8_question_id' | 'rating_9_question_id' | 'rating_10_question_id'>
  )> }
);

export type SubmitConsumptionEntryMutationVariables = Exact<{
  product_entry_id?: Maybe<Scalars['String']>;
  consumption_type_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_description?: Maybe<Scalars['String']>;
  user_rating?: Maybe<Scalars['String']>;
  rating_1_before?: Maybe<Scalars['String']>;
  rating_2_before?: Maybe<Scalars['String']>;
  rating_3_before?: Maybe<Scalars['String']>;
  rating_4_before?: Maybe<Scalars['String']>;
  rating_5_before?: Maybe<Scalars['String']>;
  rating_6_before?: Maybe<Scalars['String']>;
  rating_7_before?: Maybe<Scalars['String']>;
  rating_8_before?: Maybe<Scalars['String']>;
  rating_9_before?: Maybe<Scalars['String']>;
  rating_10_before?: Maybe<Scalars['String']>;
  rating_1_after?: Maybe<Scalars['String']>;
  rating_2_after?: Maybe<Scalars['String']>;
  rating_3_after?: Maybe<Scalars['String']>;
  rating_4_after?: Maybe<Scalars['String']>;
  rating_5_after?: Maybe<Scalars['String']>;
  rating_6_after?: Maybe<Scalars['String']>;
  rating_7_after?: Maybe<Scalars['String']>;
  rating_8_after?: Maybe<Scalars['String']>;
  rating_9_after?: Maybe<Scalars['String']>;
  rating_10_after?: Maybe<Scalars['String']>;
  rating_1_question_id?: Maybe<Scalars['String']>;
  rating_2_question_id?: Maybe<Scalars['String']>;
  rating_3_question_id?: Maybe<Scalars['String']>;
  rating_4_question_id?: Maybe<Scalars['String']>;
  rating_5_question_id?: Maybe<Scalars['String']>;
  rating_6_question_id?: Maybe<Scalars['String']>;
  rating_7_question_id?: Maybe<Scalars['String']>;
  rating_8_question_id?: Maybe<Scalars['String']>;
  rating_9_question_id?: Maybe<Scalars['String']>;
  rating_10_question_id?: Maybe<Scalars['String']>;
}>;


export type SubmitConsumptionEntryMutation = (
  { __typename?: 'mutation_root' }
  & { insert_consumption_enteries?: Maybe<(
    { __typename?: 'consumption_enteries_mutation_response' }
    & Pick<Consumption_Enteries_Mutation_Response, 'affected_rows'>
    & { returning: Array<(
      { __typename?: 'consumption_enteries' }
      & Pick<Consumption_Enteries, 'consumption_entry_id'>
    )> }
  )> }
);

export type ProductEntriesQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ProductEntriesQuery = (
  { __typename?: 'query_root' }
  & { product_entries: Array<(
    { __typename?: 'product_entries' }
    & Pick<Product_Entries, 'batch_id' | 'cbc' | 'cbd' | 'cbda' | 'cbg' | 'comments_enabled' | 'created_at' | 'delta8_thc' | 'dispensary_id' | 'fragrance_type_id' | 'variety_name' | 'user_rating_delta' | 'user_rating_description_id' | 'user_description' | 'updated_at' | 'track_trace_id' | 'thcv' | 'thca' | 'thc' | 'terpene_type_id' | 'strain_id' | 'product_type_id' | 'product_entry_id' | 'harvest_date'>
  )> }
);

export type SubmitProductEntryMutationVariables = Exact<{
  batch_id?: Maybe<Scalars['String']>;
  track_trace_id?: Maybe<Scalars['String']>;
  thc?: Maybe<Scalars['String']>;
  thca?: Maybe<Scalars['String']>;
  thcv?: Maybe<Scalars['String']>;
  delta8_thc?: Maybe<Scalars['String']>;
  cbd?: Maybe<Scalars['String']>;
  cbda?: Maybe<Scalars['String']>;
  cbg?: Maybe<Scalars['String']>;
  cbc?: Maybe<Scalars['String']>;
  comments_enabled?: Maybe<Scalars['Boolean']>;
  product_type_id?: Maybe<Scalars['String']>;
  fragrance_type_id?: Maybe<Scalars['String']>;
  terpene_type_id?: Maybe<Scalars['String']>;
  strain_id?: Maybe<Scalars['String']>;
  dispensary_id?: Maybe<Scalars['String']>;
  variety_name?: Maybe<Scalars['String']>;
  user_description?: Maybe<Scalars['String']>;
  harvest_date?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
}>;


export type SubmitProductEntryMutation = (
  { __typename?: 'mutation_root' }
  & { insert_product_entries?: Maybe<(
    { __typename?: 'product_entries_mutation_response' }
    & Pick<Product_Entries_Mutation_Response, 'affected_rows'>
    & { returning: Array<(
      { __typename?: 'product_entries' }
      & Pick<Product_Entries, 'batch_id' | 'cbc' | 'cbd' | 'cbda' | 'cbg' | 'comments_enabled' | 'created_at' | 'delta8_thc' | 'dispensary_id' | 'fragrance_type_id' | 'harvest_date' | 'product_entry_id' | 'product_type_id' | 'strain_id' | 'terpene_type_id' | 'thc' | 'thca' | 'thcv' | 'track_trace_id' | 'updated_at' | 'user_description' | 'user_rating_delta'>
    )> }
  )> }
);

export type SignInMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type SignInMutation = (
  { __typename?: 'mutation_root' }
  & { login?: Maybe<(
    { __typename?: 'LoginObject' }
    & Pick<LoginObject, 'id' | 'accessToken'>
  )> }
);

export type SignUpMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  displayName: Scalars['String'];
}>;


export type SignUpMutation = (
  { __typename?: 'mutation_root' }
  & { createUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'displayName' | 'email' | 'id'>
  )> }
);

export type SubmitUserProfileMutationVariables = Exact<{
  display_name?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  user_short_bio?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
}>;


export type SubmitUserProfileMutation = (
  { __typename?: 'mutation_root' }
  & { insert_user_profiles?: Maybe<(
    { __typename?: 'user_profiles_mutation_response' }
    & Pick<User_Profiles_Mutation_Response, 'affected_rows'>
  )> }
);

export type UpdateUserProfileMutationVariables = Exact<{
  display_name?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  user_short_bio?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
}>;


export type UpdateUserProfileMutation = (
  { __typename?: 'mutation_root' }
  & { update_user_profiles?: Maybe<(
    { __typename?: 'user_profiles_mutation_response' }
    & Pick<User_Profiles_Mutation_Response, 'affected_rows'>
  )> }
);

export type GetProfileQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProfileQuery = (
  { __typename?: 'query_root' }
  & { user_profiles: Array<(
    { __typename?: 'user_profiles' }
    & Pick<User_Profiles, 'display_name' | 'dob' | 'sex' | 'state'>
  )> }
);


export const GetConsumptionEntriesDocument = gql`
    query GetConsumptionEntries($productEntryId: String!) {
  consumption_enteries(where: {product_entry_id: {_eq: $productEntryId}}) {
    product_entry_id
    consumption_type_id
    user_id
    user_description
    user_rating
    rating_1_before
    rating_2_before
    rating_3_before
    rating_4_before
    rating_5_before
    rating_6_before
    rating_7_before
    rating_8_before
    rating_9_before
    rating_10_before
    rating_1_after
    rating_2_after
    rating_3_after
    rating_4_after
    rating_5_after
    rating_6_after
    rating_7_after
    rating_8_after
    rating_9_after
    rating_10_after
    rating_1_question_id
    rating_2_question_id
    rating_3_question_id
    rating_4_question_id
    rating_5_question_id
    rating_6_question_id
    rating_7_question_id
    rating_8_question_id
    rating_9_question_id
    rating_10_question_id
  }
}
    `;

/**
 * __useGetConsumptionEntriesQuery__
 *
 * To run a query within a React component, call `useGetConsumptionEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsumptionEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsumptionEntriesQuery({
 *   variables: {
 *      productEntryId: // value for 'productEntryId'
 *   },
 * });
 */
export function useGetConsumptionEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetConsumptionEntriesQuery, GetConsumptionEntriesQueryVariables>) {
        return Apollo.useQuery<GetConsumptionEntriesQuery, GetConsumptionEntriesQueryVariables>(GetConsumptionEntriesDocument, baseOptions);
      }
export function useGetConsumptionEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsumptionEntriesQuery, GetConsumptionEntriesQueryVariables>) {
          return Apollo.useLazyQuery<GetConsumptionEntriesQuery, GetConsumptionEntriesQueryVariables>(GetConsumptionEntriesDocument, baseOptions);
        }
export type GetConsumptionEntriesQueryHookResult = ReturnType<typeof useGetConsumptionEntriesQuery>;
export type GetConsumptionEntriesLazyQueryHookResult = ReturnType<typeof useGetConsumptionEntriesLazyQuery>;
export type GetConsumptionEntriesQueryResult = Apollo.QueryResult<GetConsumptionEntriesQuery, GetConsumptionEntriesQueryVariables>;
export const SubmitConsumptionEntryDocument = gql`
    mutation SubmitConsumptionEntry($product_entry_id: String, $consumption_type_id: String, $user_id: String, $user_description: String, $user_rating: String, $rating_1_before: String, $rating_2_before: String, $rating_3_before: String, $rating_4_before: String, $rating_5_before: String, $rating_6_before: String, $rating_7_before: String, $rating_8_before: String, $rating_9_before: String, $rating_10_before: String, $rating_1_after: String, $rating_2_after: String, $rating_3_after: String, $rating_4_after: String, $rating_5_after: String, $rating_6_after: String, $rating_7_after: String, $rating_8_after: String, $rating_9_after: String, $rating_10_after: String, $rating_1_question_id: String, $rating_2_question_id: String, $rating_3_question_id: String, $rating_4_question_id: String, $rating_5_question_id: String, $rating_6_question_id: String, $rating_7_question_id: String, $rating_8_question_id: String, $rating_9_question_id: String, $rating_10_question_id: String) {
  insert_consumption_enteries(
    objects: {product_entry_id: $product_entry_id, consumption_type_id: $consumption_type_id, user_id: $user_id, user_description: $user_description, user_rating: $user_rating, rating_1_before: $rating_1_before, rating_2_before: $rating_2_before, rating_3_before: $rating_3_before, rating_4_before: $rating_4_before, rating_5_before: $rating_5_before, rating_6_before: $rating_6_before, rating_7_before: $rating_7_before, rating_8_before: $rating_8_before, rating_9_before: $rating_9_before, rating_10_before: $rating_10_before, rating_1_after: $rating_1_after, rating_2_after: $rating_2_after, rating_3_after: $rating_3_after, rating_4_after: $rating_4_after, rating_5_after: $rating_5_after, rating_6_after: $rating_6_after, rating_7_after: $rating_7_after, rating_8_after: $rating_8_after, rating_9_after: $rating_9_after, rating_10_after: $rating_10_after, rating_1_question_id: $rating_1_question_id, rating_2_question_id: $rating_2_question_id, rating_3_question_id: $rating_3_question_id, rating_4_question_id: $rating_4_question_id, rating_5_question_id: $rating_5_question_id, rating_6_question_id: $rating_6_question_id, rating_7_question_id: $rating_7_question_id, rating_8_question_id: $rating_8_question_id, rating_9_question_id: $rating_9_question_id, rating_10_question_id: $rating_10_question_id}
  ) {
    affected_rows
    returning {
      consumption_entry_id
    }
  }
}
    `;
export type SubmitConsumptionEntryMutationFn = Apollo.MutationFunction<SubmitConsumptionEntryMutation, SubmitConsumptionEntryMutationVariables>;

/**
 * __useSubmitConsumptionEntryMutation__
 *
 * To run a mutation, you first call `useSubmitConsumptionEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitConsumptionEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitConsumptionEntryMutation, { data, loading, error }] = useSubmitConsumptionEntryMutation({
 *   variables: {
 *      product_entry_id: // value for 'product_entry_id'
 *      consumption_type_id: // value for 'consumption_type_id'
 *      user_id: // value for 'user_id'
 *      user_description: // value for 'user_description'
 *      user_rating: // value for 'user_rating'
 *      rating_1_before: // value for 'rating_1_before'
 *      rating_2_before: // value for 'rating_2_before'
 *      rating_3_before: // value for 'rating_3_before'
 *      rating_4_before: // value for 'rating_4_before'
 *      rating_5_before: // value for 'rating_5_before'
 *      rating_6_before: // value for 'rating_6_before'
 *      rating_7_before: // value for 'rating_7_before'
 *      rating_8_before: // value for 'rating_8_before'
 *      rating_9_before: // value for 'rating_9_before'
 *      rating_10_before: // value for 'rating_10_before'
 *      rating_1_after: // value for 'rating_1_after'
 *      rating_2_after: // value for 'rating_2_after'
 *      rating_3_after: // value for 'rating_3_after'
 *      rating_4_after: // value for 'rating_4_after'
 *      rating_5_after: // value for 'rating_5_after'
 *      rating_6_after: // value for 'rating_6_after'
 *      rating_7_after: // value for 'rating_7_after'
 *      rating_8_after: // value for 'rating_8_after'
 *      rating_9_after: // value for 'rating_9_after'
 *      rating_10_after: // value for 'rating_10_after'
 *      rating_1_question_id: // value for 'rating_1_question_id'
 *      rating_2_question_id: // value for 'rating_2_question_id'
 *      rating_3_question_id: // value for 'rating_3_question_id'
 *      rating_4_question_id: // value for 'rating_4_question_id'
 *      rating_5_question_id: // value for 'rating_5_question_id'
 *      rating_6_question_id: // value for 'rating_6_question_id'
 *      rating_7_question_id: // value for 'rating_7_question_id'
 *      rating_8_question_id: // value for 'rating_8_question_id'
 *      rating_9_question_id: // value for 'rating_9_question_id'
 *      rating_10_question_id: // value for 'rating_10_question_id'
 *   },
 * });
 */
export function useSubmitConsumptionEntryMutation(baseOptions?: Apollo.MutationHookOptions<SubmitConsumptionEntryMutation, SubmitConsumptionEntryMutationVariables>) {
        return Apollo.useMutation<SubmitConsumptionEntryMutation, SubmitConsumptionEntryMutationVariables>(SubmitConsumptionEntryDocument, baseOptions);
      }
export type SubmitConsumptionEntryMutationHookResult = ReturnType<typeof useSubmitConsumptionEntryMutation>;
export type SubmitConsumptionEntryMutationResult = Apollo.MutationResult<SubmitConsumptionEntryMutation>;
export type SubmitConsumptionEntryMutationOptions = Apollo.BaseMutationOptions<SubmitConsumptionEntryMutation, SubmitConsumptionEntryMutationVariables>;
export const ProductEntriesDocument = gql`
    query ProductEntries($userId: String!) {
  product_entries(where: {user_id: {_eq: $userId}}) {
    batch_id
    cbc
    cbd
    cbda
    cbg
    comments_enabled
    created_at
    delta8_thc
    dispensary_id
    fragrance_type_id
    variety_name
    user_rating_delta
    user_rating_description_id
    user_description
    updated_at
    track_trace_id
    thcv
    thca
    thc
    terpene_type_id
    strain_id
    product_type_id
    product_entry_id
    harvest_date
  }
}
    `;

/**
 * __useProductEntriesQuery__
 *
 * To run a query within a React component, call `useProductEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductEntriesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProductEntriesQuery(baseOptions: Apollo.QueryHookOptions<ProductEntriesQuery, ProductEntriesQueryVariables>) {
        return Apollo.useQuery<ProductEntriesQuery, ProductEntriesQueryVariables>(ProductEntriesDocument, baseOptions);
      }
export function useProductEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductEntriesQuery, ProductEntriesQueryVariables>) {
          return Apollo.useLazyQuery<ProductEntriesQuery, ProductEntriesQueryVariables>(ProductEntriesDocument, baseOptions);
        }
export type ProductEntriesQueryHookResult = ReturnType<typeof useProductEntriesQuery>;
export type ProductEntriesLazyQueryHookResult = ReturnType<typeof useProductEntriesLazyQuery>;
export type ProductEntriesQueryResult = Apollo.QueryResult<ProductEntriesQuery, ProductEntriesQueryVariables>;
export const SubmitProductEntryDocument = gql`
    mutation SubmitProductEntry($batch_id: String, $track_trace_id: String, $thc: String, $thca: String, $thcv: String, $delta8_thc: String, $cbd: String, $cbda: String, $cbg: String, $cbc: String, $comments_enabled: Boolean, $product_type_id: String, $fragrance_type_id: String, $terpene_type_id: String, $strain_id: String, $dispensary_id: String, $variety_name: String, $user_description: String, $harvest_date: String, $user_id: String) {
  insert_product_entries(
    objects: {batch_id: $batch_id, track_trace_id: $track_trace_id, thc: $thc, thca: $thca, thcv: $thcv, cbd: $cbd, cbda: $cbda, cbc: $cbc, cbg: $cbg, delta8_thc: $delta8_thc, dispensary_id: $dispensary_id, comments_enabled: $comments_enabled, product_type_id: $product_type_id, fragrance_type_id: $fragrance_type_id, terpene_type_id: $terpene_type_id, harvest_date: $harvest_date, strain_id: $strain_id, variety_name: $variety_name, user_description: $user_description, user_id: $user_id}
  ) {
    affected_rows
    returning {
      batch_id
      cbc
      cbd
      cbda
      cbg
      comments_enabled
      created_at
      delta8_thc
      dispensary_id
      fragrance_type_id
      harvest_date
      product_entry_id
      product_type_id
      strain_id
      terpene_type_id
      thc
      thca
      thcv
      track_trace_id
      updated_at
      user_description
      user_rating_delta
    }
  }
}
    `;
export type SubmitProductEntryMutationFn = Apollo.MutationFunction<SubmitProductEntryMutation, SubmitProductEntryMutationVariables>;

/**
 * __useSubmitProductEntryMutation__
 *
 * To run a mutation, you first call `useSubmitProductEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitProductEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitProductEntryMutation, { data, loading, error }] = useSubmitProductEntryMutation({
 *   variables: {
 *      batch_id: // value for 'batch_id'
 *      track_trace_id: // value for 'track_trace_id'
 *      thc: // value for 'thc'
 *      thca: // value for 'thca'
 *      thcv: // value for 'thcv'
 *      delta8_thc: // value for 'delta8_thc'
 *      cbd: // value for 'cbd'
 *      cbda: // value for 'cbda'
 *      cbg: // value for 'cbg'
 *      cbc: // value for 'cbc'
 *      comments_enabled: // value for 'comments_enabled'
 *      product_type_id: // value for 'product_type_id'
 *      fragrance_type_id: // value for 'fragrance_type_id'
 *      terpene_type_id: // value for 'terpene_type_id'
 *      strain_id: // value for 'strain_id'
 *      dispensary_id: // value for 'dispensary_id'
 *      variety_name: // value for 'variety_name'
 *      user_description: // value for 'user_description'
 *      harvest_date: // value for 'harvest_date'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useSubmitProductEntryMutation(baseOptions?: Apollo.MutationHookOptions<SubmitProductEntryMutation, SubmitProductEntryMutationVariables>) {
        return Apollo.useMutation<SubmitProductEntryMutation, SubmitProductEntryMutationVariables>(SubmitProductEntryDocument, baseOptions);
      }
export type SubmitProductEntryMutationHookResult = ReturnType<typeof useSubmitProductEntryMutation>;
export type SubmitProductEntryMutationResult = Apollo.MutationResult<SubmitProductEntryMutation>;
export type SubmitProductEntryMutationOptions = Apollo.BaseMutationOptions<SubmitProductEntryMutation, SubmitProductEntryMutationVariables>;
export const SignInDocument = gql`
    mutation SignIn($email: String!, $password: String!) {
  login(credentials: {email: $email, password: $password}) {
    id
    accessToken
  }
}
    `;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, baseOptions);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const SignUpDocument = gql`
    mutation SignUp($email: String!, $password: String!, $displayName: String!) {
  createUser(
    credentials: {email: $email, password: $password, displayName: $displayName}
  ) {
    displayName
    email
    id
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, baseOptions);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const SubmitUserProfileDocument = gql`
    mutation SubmitUserProfile($display_name: String, $first_name: String, $last_name: String, $user_id: String, $sex: String, $user_short_bio: String, $dob: String, $state: String) {
  insert_user_profiles(
    objects: {display_name: $display_name, first_name: $first_name, last_name: $last_name, user_id: $user_id, sex: $sex, user_short_bio: $user_short_bio, dob: $dob, state: $state}
  ) {
    affected_rows
  }
}
    `;
export type SubmitUserProfileMutationFn = Apollo.MutationFunction<SubmitUserProfileMutation, SubmitUserProfileMutationVariables>;

/**
 * __useSubmitUserProfileMutation__
 *
 * To run a mutation, you first call `useSubmitUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitUserProfileMutation, { data, loading, error }] = useSubmitUserProfileMutation({
 *   variables: {
 *      display_name: // value for 'display_name'
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      user_id: // value for 'user_id'
 *      sex: // value for 'sex'
 *      user_short_bio: // value for 'user_short_bio'
 *      dob: // value for 'dob'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSubmitUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<SubmitUserProfileMutation, SubmitUserProfileMutationVariables>) {
        return Apollo.useMutation<SubmitUserProfileMutation, SubmitUserProfileMutationVariables>(SubmitUserProfileDocument, baseOptions);
      }
export type SubmitUserProfileMutationHookResult = ReturnType<typeof useSubmitUserProfileMutation>;
export type SubmitUserProfileMutationResult = Apollo.MutationResult<SubmitUserProfileMutation>;
export type SubmitUserProfileMutationOptions = Apollo.BaseMutationOptions<SubmitUserProfileMutation, SubmitUserProfileMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation UpdateUserProfile($display_name: String, $first_name: String, $last_name: String, $user_id: String, $sex: String, $user_short_bio: String, $dob: String, $state: String) {
  update_user_profiles(
    where: {user_id: {_eq: $user_id}}
    _set: {display_name: $display_name, first_name: $first_name, last_name: $last_name, user_id: $user_id, sex: $sex, user_short_bio: $user_short_bio, dob: $dob, state: $state}
  ) {
    affected_rows
  }
}
    `;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      display_name: // value for 'display_name'
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      user_id: // value for 'user_id'
 *      sex: // value for 'sex'
 *      user_short_bio: // value for 'user_short_bio'
 *      dob: // value for 'dob'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        return Apollo.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, baseOptions);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const GetProfileDocument = gql`
    query GetProfile($id: String!) {
  user_profiles(where: {user_id: {_eq: $id}}) {
    display_name
    dob
    sex
    state
  }
}
    `;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProfileQuery(baseOptions: Apollo.QueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
        return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, baseOptions);
      }
export function useGetProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
          return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, baseOptions);
        }
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>;
export type GetProfileLazyQueryHookResult = ReturnType<typeof useGetProfileLazyQuery>;
export type GetProfileQueryResult = Apollo.QueryResult<GetProfileQuery, GetProfileQueryVariables>;